import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Spinner, InputGroup, Tabs, Tab, Modal, Table } from "react-bootstrap";
import { components } from 'react-select'
import SelectDropDown from '../selectdropdown/SelectDropDown'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import moment from "moment";
import ReportDateBlock from './ReportDateBlock';
import {
    getAuthorizedBranchIds,
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    filterByAuthorizedIds,
} from "../../utils/authHelper";
import {
    getEffectiveBranchIds,
    getEffectiveBranchCsv,
    onBranchScopeChange,
} from "../../../utils/branchScope";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";
import MultiSelect from "react-multi-select-component";
import StudentAttendanceModal from "../student_attendance/StudentAttendanceModal";
import {
    attachModuleGuard,
    AccessDeniedCard,
    AccessDeniedModal,
} from "../../../utils/moduleGuard";
import { canView } from "../../../utils/modulePermissions";
import * as XLSX from "xlsx";
import { BarChart, Bar, ComposedChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, } from "recharts";

// /attendance-regularization → granted by ANY of these three keys (see MODULE_ROUTES in
// moduleAccessGuard — a route is allowed when ANY of its keys is granted).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
//
// NOTE: this component is a pure READ-ONLY report — it has no mutations at all, so it
// only carries the is_view gate. Every write and delete for this route lives in the
// parent page, AttendanceRegularization.jsx, and is gated there.
const ATTENDANCE_REGULARIZATION_MODULE = [
    "Student_Attendance",
    "Student_Attendance_report",
    "Biometric_Attendance",
];

// The "Add Attendance" button navigates to the attendance-entry page, which is a WRITE.
// It's governed by the Student_Attendance module's "Student Attendance" sub-module, so
// gate it on is_edit of that specific row (not the broad view-key list above, which is
// only used for the read-only report's is_view gate).
const STUDENT_ATTENDANCE_MODULE = ["Student_Attendance"];
const STUDENT_ATTENDANCE_SUB = "Student Attendance";

const currentDate = new Date();

const currentMonth = currentDate.getMonth();

const currentYear = currentDate.getFullYear();

// ── Date display ──────────────────────────────────────────────────────────────
// Every user-visible date on this page is DD/MM/YYYY. Values arrive in several
// shapes, so normalise rather than assume: att_date is "2026-07-17" (the resolver's
// DATE(FROM_UNIXTIME(...))), the consolidated columns key off "17-07-2026", punch_time
// is a datetime, and some fields are unix seconds. Formatting happens at DISPLAY only —
// "17-07-2026" is also used as a lookup key (todayStr/allDates), so the values themselves
// must not be rewritten.
const DMY = "DD/MM/YYYY";
const _parseDate = (v) => {
    if (v == null || v === "") return null;
    // Unix seconds (10-digit) or a numeric string.
    if (typeof v === "number" || /^\d{9,11}$/.test(String(v).trim())) {
        return moment.unix(parseInt(v));
    }
    const m = moment(String(v), ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY", moment.ISO_8601], false);
    return m.isValid() ? m : null;
};
// Date only → "17/07/2026"
const fmtDMY = (v) => {
    const m = _parseDate(v);
    return m ? m.format(DMY) : "—";
};
// Date + time → "17/07/2026 10:30 AM"
const fmtDMYTime = (v) => {
    const m = _parseDate(v);
    return m ? m.format(`${DMY} hh:mm A`) : "—";
};

const monthOptions = Array.from(
    { length: currentMonth + 1 },
    (_, index) => ({
        value: `${currentYear}-${String(index + 1).padStart(2, "0")}`,
        label: `${new Date(
            currentYear,
            index
        ).toLocaleString("default", {
            month: "long",
        })} - ${currentYear}`,
    })
);

const styles = {
    page: {
        background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
        minHeight: "100vh",
        padding: "28px 24px",
    },
    card: {
        background: "#fff",
        borderRadius: 20,
        boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
        border: "none",
        marginBottom: 24,
        overflow: "hidden",
    },
    cardHeader: {
        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        padding: "18px 24px",
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    cardHeaderTitle: {
        color: "#fff",
        fontWeight: 700,
        fontSize: 17,
        margin: 0,
    },
    cardHeaderDot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.6)",
    },
    cardBody: {
        padding: "22px 24px",
        minHeight: "100vh",
    },
    icon: {
        width: "42px",
        height: "42px",
        borderRadius: "12px",
        background: "rgba(255,255,255,0.18)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "22px",
        backdropFilter: "blur(8px)",
    },
    addBtn: {
        background: "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
        border: "none",
        borderRadius: 10,
        padding: "9px 20px",
        fontWeight: 700,
        fontSize: 14,
        color: "#fff",
        width: "80%",
        boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
        cursor: "pointer",
    },
    input: { borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "9px 14px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%" },
    label: { fontSize: 13, fontWeight: 600, color: "#6b7280", marginBottom: 6, display: "flex", alignItems: "center", gap: 6 },
    labelIcon: { color: "#6366f1", fontSize: 13, width: 16, textAlign: "center" },
    filterSection: { marginBottom: 24, paddingBottom: 20, borderBottom: "1.5px solid #f0f4ff" },
    graphCard: {
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 2px 16px rgba(99,102,241,0.10)",
        padding: "20px 24px",
        marginBottom: 20,
        border: "1px solid #ede9fe",
    },
    graphTitle: {
        fontSize: 15,
        fontWeight: 700,
        color: "#1f2937",
        marginBottom: 14,
        paddingBottom: 10,
        borderBottom: "1.5px solid #f0f4ff",
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
    statCard: (color) => ({
        background: "#fff",
        borderTop: `4px solid ${color}`,
        borderRadius: 16,
        padding: "18px 20px",
        color: "#1f2937",
        display: "flex",
        alignItems: "center",
        gap: 16,
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        height: "100%",
    }),
    addAttendanceBtn: {
        background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
        border: "none",
        borderRadius: 8,
        padding: "8px 18px",
        fontWeight: 700,
        fontSize: 13,
        color: "#fff",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 6,
        boxShadow: "0 3px 10px rgba(16,185,129,0.3)",
    },
};


const CONSOLIDATED_FILTERS = [
    { value: 4, label: "Consolidated", icon: "fas fa-chart-bar" },
    { value: 1, label: "Class Wise", icon: "fas fa-school" },
    { value: 2, label: "Monthly Wise", icon: "far fa-calendar-alt" },
    { value: 3, label: "Student Wise", icon: "fas fa-user-graduate" },
    { value: 5, label: "Period Wise", icon: "far fa-clock" },
];

const MANUAL_FILTERS = [
    { value: 1, label: "Class Wise (Manual)", icon: "fas fa-school" },
    { value: 2, label: "Monthly Wise (Manual)", icon: "far fa-calendar-alt" },
    { value: 3, label: "Student Wise (Manual)", icon: "fas fa-user-graduate" },
    { value: 5, label: "Period Wise (Manual)", icon: "far fa-clock" },
];

const BIOMETRIC_FILTERS = [
    { value: 10, label: "Biometric Roster", icon: "fas fa-fingerprint" },
    { value: 11, label: "Raw Punch Stream", icon: "fas fa-stream" },
    { value: 12, label: "Device Sync Status (Network)", icon: "fas fa-network-wired" }
];

// NOTE: every report is multi-class — class selection lives in classSelectedvalue[], never
// in selectedClass. The biometric tabs (10/11/12) always read classSelectedvalue when
// querying, but used to render a single-class dropdown that wrote selectedClass instead,
// leaving their class filter permanently empty.

const PERIOD_STATUS_STYLES = {
    P: { background: "#dcfce7", color: "#15803d" },
    A: { background: "#fee2e2", color: "#b91c1c" },
    L: { background: "#ffedd5", color: "#c2410c" },
    H: { background: "#dbeafe", color: "#1d4ed8" },
    NM: { background: "#f3f4f6", color: "#6b7280" },
    "-": { background: "#f3f4f6", color: "#6b7280" },
};

const GET_ACADEMIC_YEARS = gql`
    query getAcademicYears($id: Int) {
        getAcademicYears(id: $id) {
            id
            academic_year
        }
    }
`;

const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                stream_id
                section_name
            }
        }
    }
`;

const GET_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;

const GET_STREAMS = gql`
    query {
        getStreams {
            id
            stream
        }
    }
`;

// Classes that require a stream selection (e.g. Intermediate 1st/2nd year)
const STREAM_CLASS_IDS = [15, 16];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));


const GET_MULTI_DATE_ATTENDANCE_REPORT = gql`
  query getMultiDateAttendanceReport(
    $academic_year_id: Int!
    $institute_id: Int!
    $branch_id: Int
    $branch_ids: String
    $class_id: String
    $section_id: String
    $from_date: String
    $to_date: String
    $mainSource: String
  ) {
    getMultiDateAttendanceReport(
      academic_year_id: $academic_year_id
      institute_id: $institute_id
      branch_id: $branch_id
      branch_ids: $branch_ids
      class_id: $class_id
      section_id: $section_id
      from_date: $from_date
      to_date: $to_date
      mainSource: $mainSource
    ) {
      class_id
      section_id
      branch_id
      att_date
      total_students
      present
      absent
      percentage
    }
  }
`;

const GET_CONSOLIDATED_DAYWISE_ATTENDANCE_REPORT = gql`
  query getConsolidatedDaywiseAttendanceReport(
    $institute_id: Int!
    $month: String
    $academic_year_id: Int!
    $branch_id: String
    $class_id: String
    $section_id: String
    $mainSource: String
  ) {
    getConsolidatedDaywiseAttendanceReport(
      institute_id: $institute_id
      month: $month
      academic_year_id: $academic_year_id
      branch_id: $branch_id
      class_id: $class_id
      section_id: $section_id
      mainSource: $mainSource
    ) {
      sr_no
      class_id
      class_name
      branch_id
      section_id
      total_students
      dateWiseData {
        date
        present
        absent
        total
      }
    }
  }
`;

const GET_STUDENT_ATTENDANCE_REPORT_DETAILS = gql`
  query getStudentAttendanceReportDetails(
    $academic_year_id: Int!
    $institute_id: Int!
    $branch_id: Int
    $branch_ids: String
    $class_id: String
    $section_id: String
    $from_date: String
    $to_date: String
    $mainSource: String
  ) {
    getStudentAttendanceReportDetails(
      academic_year_id: $academic_year_id
      institute_id: $institute_id
      branch_id: $branch_id
      branch_ids: $branch_ids
      class_id: $class_id
      section_id: $section_id
      from_date: $from_date
      to_date: $to_date
      mainSource: $mainSource
    ) {
      id
      admission_no
      not_marked
      roll_no
      student_name
      student_mobile
      branch_id
      class_id
      section_id
      working_days
      present
      absent
      father_name
      father_phone
      mother_name
      dob
      attendance_percentage
    }
  }
`;

const GET_STUDENT_BIOMETRIC_LOGS = gql`
  query getStudentBiometricLogs($admission_no: String!, $institute_id: Int) {
    getStudentBiometricLogs(admission_no: $admission_no, institute_id: $institute_id) {
      biometric_user_id
      name
      admission_no
      edu_student_id
      logs {
        id
        punch_type
        punch_time
        device_id
        sync_at
      }
    }
  }
`;

const GET_MARKED_STUDENT_ATTENDANCE = gql`
  query getMarkedStudentAttendance($edu_student_id: Int, $date: String, $attendance_subtype_id: Int) {
    getMarkedStudentAttendance(edu_student_id: $edu_student_id, date: $date, attendance_subtype_id: $attendance_subtype_id) {
      id
      edu_student_id
      attendance_subtype_id
      class_id
      date
      attended_status
      attended_status_name
      comments
      inserted_by
      inserted_time
    }
  }
`;

const GET_MONTHLY_ATTENDANCE_REPORT = gql`
  query getMonthlyAttendanceReport(
    $academic_year_id: Int!
    $institute_id: Int!
    $branch_id: Int
    $branch_ids: String
    $class_id: Int
    $class_ids: String
    $section_id: String
    $month: String
    $mainSource: String
  ) {
    getMonthlyAttendanceReport(
      academic_year_id: $academic_year_id
      institute_id: $institute_id
      branch_id: $branch_id
      branch_ids: $branch_ids
      class_id: $class_id
      class_ids: $class_ids
      section_id: $section_id
      month: $month
      mainSource: $mainSource
    ) {
      student_id
      admission_no
      student_name
      student_mobile
      roll_no
      class_id
      section_id
      branch_id
      total_present
      total_absent
      total_working_days
      percentage
      father_name
      father_phone
      mother_name
      mother_phone
      dob
      days {
        day
        status
      }
    }
  }
`;

const GET_PERIODWISE_ATTENDANCE_REPORT = gql`
  query getPeriodwiseAttendanceReport(
    $academic_year_id: Int!
    $branch_id: String
    $class_id: String
    $institute_id: Int!
    $month: String
    $section_id: String
  ) {
    getPeriodwiseAttendanceReport(
      academic_year_id: $academic_year_id
      branch_id: $branch_id
      class_id: $class_id
      institute_id: $institute_id
      month: $month
      section_id: $section_id
    ) {
      sr_no
      student_id
      roll_no
      section_id
      student_name
      student_mobile
      father_name
      father_phone
      mother_name
      dob
      class_id
      branch_id
      academic_year_id
      dateWiseData {
        date
        day_of_week
        is_holiday
        periods {
          period_no
          subtype_id
          subtype_name
          status
        }
      }
    }
  }
`;

const GET_ORGANISATION_PROFILE = gql`
    query($institution_id: Int!) {
        getOrganisationProfile(institution_id: $institution_id) {
            id
            organisation_name
            logo
            complete_address
        }
    }
`;

class StudentAttendanceReportHome extends React.Component {
    constructor(props) {
        super(props);
        const initialSource = props.mainSource || "combined";
        const defaultSelected = initialSource === "biometric" ? 10 : (initialSource === "manual" ? 1 : 4);
        this.state = {
            selected: defaultSelected,
            mainSource: initialSource,
            attendanceModalShow: false,
            // Biometric punch-log modal (Student Wise → click a student)
            bioModalOpen: false,
            bioLoading: false,
            bioStudent: null,
            bioData: null,
            bioError: "",
            selectedReportStudent: null,
            bioLogs: [],
            manualLogs: [],
            detailsLoading: false,
            detailsError: "",
            selectedYear: "",
            selectedClass: "",
            selectedClassesArr: [],
            streamSelectedvalue: null,
            allStreams: [],
            startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
            branchData: [],
            selectedBranch: "",
            selectedSection: "",
            isClassFilterLoader: 0,
            selectedMonthId: "",
            currentPage: 0,
            showConfig: false,
            isSubmitting: false,
            attendanceReport: [],
            hasSearched: false,
            classSelectedvalue: [],
            sectionSelectedvalue: [],
            branchSelectedvalue: [],
            yearSelectedvalue: [],
            monthSelectedvalue: [],
            classError: "",
            sectionError: "",
            isBranchLoading: false,
            monthlyBarsVisible: { "Working Days": true, Present: true, Absent: true },
            trend1BarsVisible: { Total: true, Present: true, Absent: true, "Attendance %": true },
            overview3BarsVisible: { "Working Days": true, Present: true, Absent: true },
            consolidated4BarsVisible: { Present: true, Absent: true, Total: true },
            orgProfile: {},
            periodWiseSearch: "",
            periodWisePage: 1,
            periodWisePageSize: 10,
            consolidated4Search: "",
            consolidated4Page: 1,
            consolidated4PageSize: 10,
            // Period Wise: freeze the identity columns (default on; user can unfreeze).
            periodWiseFreeze: true,
            accessDeniedShow: false,
        };

        this.guard = attachModuleGuard(this, ATTENDANCE_REGULARIZATION_MODULE);
        // Separate guard for the "Add Attendance" write action, scoped to the
        // Student_Attendance / "Student Attendance" grant. Shares the same accessDeniedShow
        // flag, so one AccessDeniedModal serves it.
        this.addAttendanceGuard = attachModuleGuard(this, STUDENT_ATTENDANCE_MODULE, STUDENT_ATTENDANCE_SUB);
        // Horizontal scroll container for the Consolidated table + the "today" column
        // node, so we can auto-scroll today's column into view.
        this.cons4ScrollRef = React.createRef();
        this._todayColNode = null;
        // Same, for the Period Wise table.
        this.pwScrollRef = React.createRef();
        this._pwTodayColNode = null;
    }

    /** Period Wise: ref callback on the "today" date header — scrolls it into view. */
    setPwTodayColRef = (node) => {
        this._pwTodayColNode = node || null;
        if (node) setTimeout(this.scrollPwToToday, 0);
    };

    scrollPwToToday = () => {
        const c = this.pwScrollRef && this.pwScrollRef.current;
        const node = this._pwTodayColNode;
        if (!c || !node) return;
        // Land today just past the frozen identity block (≈740px) when frozen.
        const freeze = this.state.periodWiseFreeze !== false;
        const target = Math.max(0, node.offsetLeft - (freeze ? 760 : 24));
        try { c.scrollTo({ left: target, behavior: "smooth" }); }
        catch (e) { c.scrollLeft = target; }
    };

    togglePeriodWiseFreeze = () =>
        this.setState((s) => ({ periodWiseFreeze: !(s.periodWiseFreeze !== false) }));

    /** Ref callback on the "today" header cell — scrolls it into view once on mount. */
    setTodayColRef = (node) => {
        this._todayColNode = node || null;
        if (node) setTimeout(this.scrollToToday, 0);
    };

    /** Horizontal-only scroll (never moves the page) to land today's column just
     *  past the 4 sticky identity columns. */
    scrollToToday = () => {
        const c = this.cons4ScrollRef && this.cons4ScrollRef.current;
        const node = this._todayColNode;
        if (!c || !node) return;
        const target = Math.max(0, node.offsetLeft - 380);
        try { c.scrollTo({ left: target, behavior: "smooth" }); }
        catch (e) { c.scrollLeft = target; }
    };

    initializeBranchSelection = (branchObj, branches, allClasses) => {
        if (!branchObj) {
            return {
                selectedBranch: "",
                selectedClass: "",
                selectedSection: "",
                getClasses: [],
                getSections: [],
                classSelectedvalue: [],
                sectionSelectedvalue: [],
            };
        }

        // Default the pickers across every branch the header has in scope, not just branchObj
        // (the primary device's branch). Otherwise "All Branches" would still default to one
        // branch's classes and sections, and the query — which filters on those section ids —
        // would quietly report on that branch alone.
        // Branch scope always comes from outside this page now, so never fall back to
        // branchObj (the primary device's branch) — that would repopulate Class/Section
        // from one branch regardless of what is actually in scope.
        const inScope = this.inScopeBranches(branches);

        const classArr = this.sortByLabelAsc(
            [...new Set(inScope.flatMap((b) => b.sections.map((s) => s.class_id)))]
                .map((classId) => {
                    const classData = allClasses.find((c) => +c.id === +classId);
                    return classData ? { value: classData.id, label: classData.class } : null;
                })
                .filter(Boolean)
        );
        const selectedClass = classArr.length > 0 ? classArr[0] : null;
        const sectionArr = selectedClass
            ? this.buildSectionOptions(inScope, (s) => +s.class_id === +selectedClass.value)
            : [];
        const selectedSection = sectionArr.length > 0 ? sectionArr[0] : null;

        const allSectionArr = this.buildSectionOptions(inScope);

        return {
            selectedBranch: branchObj.id || "",
            selectedClass: selectedClass?.value || "",
            selectedSection: selectedSection?.value || "",
            getClasses: classArr,
            getSections: allSectionArr,
            classSelectedvalue: classArr || [],
            // Class defaults to every class, so sections must span every class too. Defaulting
            // to the first class's sections only (the old single-class behaviour) would show
            // "All Classes selected" while quietly reporting on just one of them.
            sectionSelectedvalue: allSectionArr,
            branchSelectedvalue: [{ value: branchObj.id, label: branchObj.branch_name }],
        };
    };

    applyBranchChange = (branchObj, branches, allClasses) => {
        if (this.state.selected === 4 || this.state.selected === 5) {
            const consolidatedDefaults = this.buildConsolidatedSelections(branches, allClasses);
            return {
                selectedBranch: branchObj?.id || "",
                selectedClass: consolidatedDefaults.classSelectedvalue[0]?.value || "",
                selectedSection: consolidatedDefaults.sectionSelectedvalue[0]?.value || "",
                ...consolidatedDefaults,
            };
        } else {
            return this.initializeBranchSelection(branchObj, branches, allClasses);
        }
    };

    componentDidMount() {
        // is_view === 0 → don't fetch anything. These three are imperative client.query()
        // calls, so the `skip` on the HOCs below doesn't cover them — bailing out here is
        // what keeps the attendance data off the wire.
        if (!this.guard.canView()) return;

        this.getBranches();
        this.getStreamsList();
        this.loadOrgProfile();
        // Standalone page: branch comes from the header multi-select (NavbarOne), so
        // re-scope when it changes. (When a parent drives branchIds, componentDidUpdate
        // already covers it.)
        this.offBranchScope = onBranchScopeChange(() => this.getBranches());
        // If Apollo serves data from cache on first render, componentDidUpdate won't fire
        // because the prop never changes — initialize year here as a fallback.
        const academicYears = this.props.getAcademicYearsQuery?.getAcademicYears || [];

        const currentDate = new Date();

        const currentMonthValue =
            `${currentDate.getFullYear()}-${String(
                currentDate.getMonth() + 1
            ).padStart(2, "0")}`;


        if (academicYears.length > 0) {
            const firstYear = academicYears[0];
            const currentMonthOption = monthOptions.find((m) => m.value === currentMonthValue);
            this.setState({
                selectedYear: firstYear.id,
                selectedMonthId: currentMonthValue,
                yearSelectedvalue: [{ value: firstYear.id, label: firstYear.academic_year }],
                monthSelectedvalue: currentMonthOption ? [currentMonthOption] : [],
            });
        }


    };

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    // Branch scope changed (parent prop, or the header multi-select) → re-derive the
    // class/section pickers from the new scope and refetch.
    rescopeToBranchSelection = () => {
        const branches = this.state.branchData || [];
        const allClasses = this.props.getClassesQuery?.getExamClasses || [];
        if (branches.length === 0) return;
        const forced = this.props.branchId != null && String(this.props.branchId) !== ""
            ? Number(this.props.branchId) : null;
        const target = forced != null
            ? (branches.find((b) => Number(b.id) === forced) || branches[0])
            : branches[0];
        const branchState = this.applyBranchChange(target, branches, allClasses);
        this.setState(branchState, this.autoFetchIfReady);
    };

    componentDidUpdate(prevProps, prevState) {
        // is_view === 0 → this re-reads the (now skipped) query props and calls
        // autoFetchIfReady, so it has to bail too or the reads restart on every update.
        if (!this.guard.canView()) return;

        // Parent (attendance console) changed the branch selection → re-scope the report so
        // the pickers stay in SYNC. branchIds is checked too: branchId is null for both "all
        // branches" and "2+ branches", so going 2 → 3 branches never changes it and would
        // otherwise leave the class/section options derived from the old scope.
        if (prevProps.branchId !== this.props.branchId || prevProps.branchIds !== this.props.branchIds) {
            this.rescopeToBranchSelection();
        }

        // Academic Years
        if (
            prevProps.getAcademicYearsQuery !==
            this.props.getAcademicYearsQuery
        ) {
            const academicYears =
                this.props.getAcademicYearsQuery
                    ?.getAcademicYears || [];

            const firstYear = academicYears.length > 0 ? academicYears[0] : null;
            this.setState({
                selectedYear: firstYear?.id || "",
                yearSelectedvalue: firstYear ? [{ value: firstYear.id, label: firstYear.academic_year }] : [],
            }, this.autoFetchIfReady);
        }

        // Branch + Class + Section
        // Only re-init when getClassesQuery arrives (branch init is handled in getBranches()).
        // When only branchData changed, getBranches() already set selections — skip to avoid double fetch.
        if (
            (prevState.branchData !== this.state.branchData &&
                ((this.state.selected === 4 || this.state.selected === 5) || !this.state.selectedBranch)) ||
            prevProps.getClassesQuery !== this.props.getClassesQuery
        ) {
            const branches = this.state.branchData || [];
            const allClasses = this.props.getClassesQuery?.getExamClasses || [];

            const forcedBranchId = this.props.branchId != null && String(this.props.branchId) !== ""
                ? Number(this.props.branchId) : null;
            const defaultBranch = forcedBranchId != null
                ? (branches.find((b) => Number(b.id) === forcedBranchId) || (branches.length > 0 ? branches[0] : null))
                : (branches.length > 0 ? branches[0] : null);

            if (branches.length > 0 && defaultBranch) {
                const branchState = this.applyBranchChange(defaultBranch, branches, allClasses);
                this.setState(branchState, this.autoFetchIfReady);
            }
        }
    }

    getStreamsList = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_STREAMS,
                fetchPolicy: "network-only",
            });
            this.setState({ allStreams: result.data.getStreams || [] });
        } catch {
            // ignore
        }
    };

    getBranches = async () => {
        this.setState({ isBranchLoading: true });
        try {
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            let branches = (result.data.getBranches || []);
            // Show only the branches, classes, and sections the user is authorized for.
            const authorizedIds = getAuthorizedBranchIds();
            const authorizedClassIds = getAuthorizedClassIds();
            const authorizedSectionIds = getAuthorizedSectionIds();

            if (authorizedIds.length) {
                branches = branches.filter((b) => authorizedIds.includes(String(b.id)));
            }

            branches = branches.map((b) => {
                let sec = b.sections || [];
                if (authorizedClassIds.length) {
                    sec = sec.filter((s) => authorizedClassIds.includes(String(s.class_id)));
                }
                if (authorizedSectionIds.length) {
                    sec = sec.filter((s) => authorizedSectionIds.includes(String(s.id)));
                }
                return { ...b, sections: sec };
            });

            const allClasses = this.props.getClassesQuery?.getExamClasses || [];

            const forcedBranchId = this.props.branchId != null && String(this.props.branchId) !== ""
                ? Number(this.props.branchId) : null;
            const selectedBranchObj = forcedBranchId != null
                ? (branches.find(b => Number(b.id) === forcedBranchId) || (branches.length > 0 ? branches[0] : null))
                : (branches.length > 0 ? branches[0] : null);

            const currentMonthValue = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}`;
            const currentMonthOption = monthOptions.find((m) => m.value === currentMonthValue);

            const branchState = this.applyBranchChange(selectedBranchObj, branches, allClasses);

            this.setState({
                branchData: branches,
                ...branchState,
                selectedMonthId: currentMonthValue,
                monthSelectedvalue: currentMonthOption ? [currentMonthOption] : [],
                isBranchLoading: false,
            }, this.autoFetchIfReady);
        } catch {
            this.setState({ isBranchLoading: false });
        }
    };

    // handleSelect = (value) => {
    //     this.setState({
    //         selected: value,
    //         isClassFilterLoader: 0,
    //         attendanceReport: [],
    //         hasSearched: false,
    //         // classSelectedvalue: [],
    //         // sectionSelectedvalue: [],
    //         classError: "",
    //         sectionError: "",
    //     }, this.autoFetchIfReady);
    // };

    handleSelect = (value) => {
        const { branchData } = this.state;
        const allClasses = this.props.getClassesQuery?.getExamClasses || [];

        if (value === 4 || value === 5) {
            const consolidated = this.buildConsolidatedSelections(branchData, allClasses);
            const monthSelection = this.getCurrentMonthSelection();
            const academicYears = this.props.getAcademicYearsQuery?.getAcademicYears || [];
            const activeYear = academicYears.find((y) => String(y.id) === String(this.state.selectedYear)) || academicYears[0];
            this.setState({
                selected: value,
                isClassFilterLoader: 0,
                attendanceReport: [],
                hasSearched: false,
                selectedBranch: branchData[0]?.id || "",
                selectedClass: consolidated.classSelectedvalue[0]?.value || "",
                selectedSection: consolidated.sectionSelectedvalue[0]?.value || "",
                ...consolidated,
                streamSelectedvalue: null,
                ...monthSelection,
                yearSelectedvalue: activeYear ? [{ value: activeYear.id, label: activeYear.academic_year }] : this.state.yearSelectedvalue,
                classError: "",
                sectionError: "",
                startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
                endDateCalender: moment(new Date()).startOf('day').unix(),
            }, this.autoFetchIfReady);
            return;
        }

        const selectedBranchObj = branchData.length > 0 ? branchData[0] : null;
        // Same rule as initializeBranchSelection: span every branch the header has in scope,
        // and never fall back to a branch when the header has none ticked.
        const inScope = this.inScopeBranches(branchData);

        const classArr = inScope.length
            ? this.sortByLabelAsc(
                [...new Set(inScope.flatMap((b) => b.sections.map((s) => s.class_id)))]
                    .map((classId) => {
                        const classData = allClasses.find((c) => +c.id === +classId);
                        return classData ? { value: classData.id, label: classData.class } : null;
                    })
                    .filter(Boolean)
            )
            : [];
        const selectedClass = classArr.length > 0 ? classArr[0] : null;
        const sectionArr = selectedClass
            ? this.buildSectionOptions(inScope, (s) => +s.class_id === +selectedClass.value)
            : [];
        const selectedSection = sectionArr.length > 0 ? sectionArr[0] : null;
        const allSectionArr = this.buildSectionOptions(inScope);

        this.setState({
            selected: value,
            isClassFilterLoader: 0,
            attendanceReport: [],
            hasSearched: false,
            selectedBranch: selectedBranchObj?.id || "",
            selectedClass: selectedClass?.value || "",
            selectedSection: selectedSection?.value || "",
            branchSelectedvalue: selectedBranchObj ? [{ value: selectedBranchObj.id, label: selectedBranchObj.branch_name }] : [],
            classSelectedvalue: classArr || [],
            streamSelectedvalue: null,
            // Every class is selected by default, so default sections to every class's too.
            sectionSelectedvalue: allSectionArr,
            classError: "",
            sectionError: "",
        }, this.autoFetchIfReady);
    };

    getFilterLookupMaps = () => {
        const allClasses = this.props.getClassesQuery?.getExamClasses || [];
        const classMap = {};
        allClasses.forEach((c) => {
            classMap[c.id] = c.class;
            classMap[String(c.id)] = c.class;
        });

        const branchMap = {};
        const sectionMap = {};
        (this.state.branchData || []).forEach((b) => {
            branchMap[b.id] = b.branch_name;
            branchMap[String(b.id)] = b.branch_name;
            (b.sections || []).forEach((s) => {
                sectionMap[s.id] = s.section_name;
                sectionMap[String(s.id)] = s.section_name;
            });
        });

        return { classMap, branchMap, sectionMap };
    };

    /** Ascending order for { value, label } multi-select / option rows */
    sortByLabelAsc = (items) =>
        [...items].sort((a, b) =>
            String(a.value ?? "").localeCompare(String(b.value ?? ""), undefined, { sensitivity: "base", numeric: true })
        );

    sortSectionsByClassThenLabel = (items) =>
        [...items].sort((a, b) => {
            const byClass = String(a.class_id ?? "").localeCompare(String(b.class_id ?? ""), undefined, { numeric: true });
            if (byClass !== 0) return byClass;
            return String(a.value ?? "").localeCompare(String(b.value ?? ""), undefined, { sensitivity: "base", numeric: true });
        });

    sortAcademicYearsAsc = (years) =>
        [...(years || [])].sort((a, b) =>
            String(a.academic_year ?? "").localeCompare(String(b.academic_year ?? ""), undefined, { numeric: true })
        );

    buildConsolidatedSelections = (branches, allClasses) => {
        // Scope to exactly what the header has ticked. branchIds is the authority when the
        // parent drives it: "359,370" = those two, empty = NONE (so no classes/sections).
        // The old code keyed off branchId alone, which is null for both "none" and "2+
        // branches", and fell through to `branches` — every branch. That is why Consolidated
        // still listed every class and section with no branch selected.
        // On the standalone page the same rule applies, with the header as the authority.
        const branchList = this.inScopeBranches(branches);
        const branchSelectedvalue = branchList.map((b) => ({
            value: b.id,
            label: b.branch_name,
        }));
        const allClassIds = [...new Set(branchList.flatMap((b) => (b.sections || []).map((s) => s.class_id)))];
        const classSelectedvalue = this.sortByLabelAsc(
            allClassIds
                .map((classId) => {
                    const classData = (allClasses || []).find((c) => +c.id === +classId);
                    return classData ? { value: classData.id, label: classData.class } : null;
                })
                .filter(Boolean)
        );
        const sectionSelectedvalue = this.buildSectionOptions(branchList);
        return { branchSelectedvalue, classSelectedvalue, sectionSelectedvalue };
    };

    getCurrentMonthSelection = () => {
        const currentMonthValue = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}`;
        const currentMonthOption = monthOptions.find((m) => m.value === currentMonthValue);
        return {
            selectedMonthId: currentMonthValue,
            monthSelectedvalue: currentMonthOption ? [currentMonthOption] : [],
        };
    };

    resolveClassName = (classId) => {
        const { classMap } = this.getFilterLookupMaps();
        if (classId == null || classId === "") return "-";
        return classMap[classId] ?? classMap[String(classId)] ?? classId;
    };

    resolveSectionName = (sectionId) => {
        const { sectionMap } = this.getFilterLookupMaps();
        if (sectionId == null || sectionId === "") return "-";
        return sectionMap[sectionId] ?? sectionMap[String(sectionId)] ?? sectionId;
    };

    resolveBranchName = (branchId) => {
        const { branchMap } = this.getFilterLookupMaps();
        if (branchId == null || branchId === "") return "-";
        return branchMap[branchId] ?? branchMap[String(branchId)] ?? branchId;
    };

    handleDropdown = (field, e) => {
        const value = e.target.value;
        if (field === "selectedYear") {
            const academicYears = this.props.getAcademicYearsQuery?.getAcademicYears || [];
            const yearOption = academicYears.find((y) => String(y.id) === String(value));
            const yearPatch = {
                selectedYear: value,
                yearSelectedvalue: yearOption ? [{ value: yearOption.id, label: yearOption.academic_year }] : [],
                isClassFilterLoader: 0,
                attendanceReport: [],
                hasSearched: false,
                classError: "",
                sectionError: "",
            };
            if (this.state.selected !== 4 && this.state.selected !== 5) {
                Object.assign(yearPatch, {
                    selectedBranch: "",
                    selectedClass: "",
                    selectedSection: "",
                });
            }
            this.setState(yearPatch, this.autoFetchIfReady);
        } else if (field === "selectedMonthId") {
            const monthOption = monthOptions.find((m) => m.value === value);
            this.setState({
                selectedMonthId: value,
                monthSelectedvalue: monthOption ? [monthOption] : [],
                attendanceReport: [],
                hasSearched: false,
            }, this.autoFetchIfReady);
        } else if (field === "selectedBranch") {
            const selectedBranchObj = (this.state.branchData || []).find(
                (b) => +b.id === +value
            );
            const allClasses = this.props.getClassesQuery?.getExamClasses || [];
            const branchState = this.applyBranchChange(selectedBranchObj, this.state.branchData, allClasses);
            this.setState({
                ...branchState,
                isClassFilterLoader: 0,
                attendanceReport: [],
                hasSearched: false,
                classError: "",
                sectionError: "",
            }, this.autoFetchIfReady);
        // NOTE: there is no "selectedClass" case — class is multi-select on every tab now and
        // is handled by handleMultipleSelectInputChange(e, "class"). The single-class dropdown
        // that used to dispatch here no longer exists.
        } else {
            this.setState({ [field]: value }, this.autoFetchIfReady);
        }
    };

    handleClassMultiSelect = (e) => {

    };

    // Which branches' classes/sections are in scope. When a parent drives the header filter
    // it passes branchIds, and that is the authority: "359,370" = those two, "" / null = All
    // Branches = every one. Deriving from this.state.selectedBranch instead (the old path)
    // pinned the pickers to a single branch — the primary device's — so with all 7 branches
    // ticked you could still only choose Nizampet's classes and sections.
    // branchList is passed explicitly during init, when this.state.branchData isn't set yet.
    inScopeBranches = (branchList) => {
        const all = branchList || this.state.branchData || [];
        const authBranchIds = getAuthorizedBranchIds();
        const ids = this.branchScopeIds();
        let res = [];
        if (this.props.branchIds !== undefined) {
            // Parent-driven: empty = no branch ticked = nothing in scope, so the class/
            // section pickers come up empty. It does NOT mean "every branch" — the parent
            // ticks all by default, so an empty selection is a deliberate clear.
            res = ids.length ? all.filter((b) => ids.includes(+b.id)) : [];
        } else {
            // Header-driven (NavbarOne): no ids at all means the user is unrestricted and
            // has narrowed nothing, which is every branch.
            res = ids.length ? all.filter((b) => ids.includes(+b.id)) : all;
        }

        if (authBranchIds.length > 0) {
            res = res.filter((b) => authBranchIds.includes(String(b.id)));
        }
        return res;
    };

    // Section names repeat across branches ("NJA - 1" exists in more than one), so qualify
    // them with the branch once more than one branch is in scope. Ids stay unique regardless.
    buildSectionOptions = (branches, sectionFilter) => {
        const qualify = (branches || []).length > 1;
        const authSecIds = getAuthorizedSectionIds();
        const authClassIds = getAuthorizedClassIds();

        return this.sortSectionsByClassThenLabel(
            (branches || []).flatMap((b) =>
                (b.sections || [])
                    .filter((s) => {
                        if (authSecIds.length > 0 && !authSecIds.includes(String(s.id))) return false;
                        if (authClassIds.length > 0 && !authClassIds.includes(String(s.class_id))) return false;
                        return sectionFilter ? sectionFilter(s) : true;
                    })
                    .map((s) => ({
                        value: s.id,
                        label: qualify ? `${s.section_name} (${b.branch_name})` : s.section_name,
                        class_id: s.class_id,
                        branch_id: b.id,
                    }))
            )
        );
    };

    handleMultipleSelectInputChange = (selectedOptions, field) => {
        if (field === "class") {
            const newSectionArr = this.buildSectionOptions(this.inScopeBranches(), (s) =>
                selectedOptions.some((cv) => +cv.value === +s.class_id)
            );
            this.setState({
                classSelectedvalue: selectedOptions,
                streamSelectedvalue: null,
                sectionSelectedvalue: newSectionArr,
                classError: "",
                attendanceReport: [],
                hasSearched: false,
            }, this.autoFetchIfReady);
        } else if (field === "section") {
            this.setState({
                sectionSelectedvalue: selectedOptions,
                sectionError: "",
                attendanceReport: [],
                hasSearched: false,
            }, this.autoFetchIfReady);
        } else if (field === "stream") {
            // Stream only narrows sections (sections carry stream_id). Re-derive the section
            // selection to all in-scope sections that match the chosen streams (empty = all).
            const classMatch = (s) => {
                if (!this.state.classSelectedvalue.length) return true;
                return this.state.classSelectedvalue.some((cv) => +cv.value === +s.class_id);
            };
            const newSectionArr = this.buildSectionOptions(this.inScopeBranches(), (s) => {
                if (!classMatch(s)) return false;
                if (isStreamClass(s.class_id) && selectedOptions.length > 0) {
                    return selectedOptions.some((sv) => +sv.value === +s.stream_id);
                }
                return true;
            });
            this.setState({
                streamSelectedvalue: selectedOptions,
                sectionSelectedvalue: newSectionArr,
                sectionError: "",
                attendanceReport: [],
                hasSearched: false,
            }, this.autoFetchIfReady);
        } else if (field === "branch") {
            const allClasses = this.props.getClassesQuery?.getExamClasses || [];
            const selectedBranchesData = (this.state.branchData || []).filter((b) =>
                selectedOptions.some((bv) => +bv.value === +b.id)
            );
            const allClassIds = [...new Set(selectedBranchesData.flatMap((b) => b.sections.map((s) => s.class_id)))];
            const newClassArr = this.sortByLabelAsc(
                allClassIds
                    .map((classId) => {
                        const classData = allClasses.find((c) => +c.id === +classId);
                        return classData ? { value: classData.id, label: classData.class } : null;
                    })
                    .filter(Boolean)
            );
            const newSectionArr = this.buildSectionOptions(selectedBranchesData);
            this.setState({
                branchSelectedvalue: selectedOptions,
                classSelectedvalue: newClassArr,
                streamSelectedvalue: null,
                sectionSelectedvalue: newSectionArr,
                attendanceReport: [],
                hasSearched: false,
            }, this.autoFetchIfReady);
        } else if (field === "year") {
            this.setState({
                yearSelectedvalue: selectedOptions,
                attendanceReport: [],
                hasSearched: false,
            }, this.autoFetchIfReady);
        } else if (field === "month") {
            this.setState({
                monthSelectedvalue: selectedOptions,
                attendanceReport: [],
                hasSearched: false,
            }, this.autoFetchIfReady);
        }
    };

    applyCallback = (startDate, endDate) => {
        this.setState({
            startDateCalender: startDate.unix(),
            endDateCalender: endDate.unix(),
            attendanceReport: [],
            hasSearched: false,
        }, this.autoFetchIfReady)
    }

    // A branch can come from either side: this component's own picker, or the branchIds prop
    // that attendance-regularization drives. With 2+ branches picked upstream the single-branch
    // state is deliberately left empty, so checking state alone would block a valid search.
    hasBranchSelection = () => {
        // Branch is never picked on this page. Parent-driven: an empty branchIds means
        // nothing is ticked upstream, so there is nothing to query. Header-driven: the
        // scope is always non-empty (an empty selection means every authorized branch).
        if (this.props.branchIds !== undefined) return Boolean(this.props.branchIds);
        return true;
    };

    // ── Branch scope ────────────────────────────────────────────────────────────
    // Branch is chosen once, off this page: attendance-regularization drives it through
    // the branchIds prop, and everywhere else it comes from the header multi-select
    // (NavbarOne). This component renders no branch picker of its own.
    branchScopeIds = () => {
        if (this.props.branchIds !== undefined) {
            return String(this.props.branchIds || "")
                .split(",")
                .map((x) => parseInt(x.trim()))
                .filter(Boolean);
        }
        return getEffectiveBranchIds().map(Number).filter(Boolean);
    };

    // CSV form for the queries' branch_ids argument; null = no narrowing.
    branchScopeCsv = () => {
        if (this.props.branchIds !== undefined) return this.props.branchIds || null;
        return getEffectiveBranchCsv() || null;
    };

    handleClassWiseReportSubmit = async () => {
        const { selectedYear, selectedBranch, selectedClass, selectedSection, selected, selectedMonthId, startDateCalender, endDateCalender } = this.state;

        if (selected === 4 || selected === 5) {
            if (!selectedYear) { return; }
            if (!this.hasBranchSelection()) { return; }
            if (!this.state.classSelectedvalue.length) { return; }
            if (!this.state.sectionSelectedvalue.length) { return; }
            if (!selectedMonthId) { return; }
        } else {
            if (!selectedYear) { return; }
            if (!this.hasBranchSelection()) { return; }
            // Every tab is multi-class now, so class always comes from classSelectedvalue.
            if (!this.state.classSelectedvalue.length) { return; }
            if (!this.state.sectionSelectedvalue.length) { return; }
            if (selected === 2) { if (!selectedMonthId) { return; } }
        }

        const sectionIds = this.state.sectionSelectedvalue.map((s) => String(s.value)).join(",");
        // Class is multi-select on every tab now — always a CSV ("15,16"), never one id.
        const classIds = this.state.classSelectedvalue.map((c) => String(c.value)).join(",");

        this.setState({ isClassFilterLoader: 1, attendanceReport: [] });

        try {
            let data = [];
            if (selected === 1) {
                const res = await this.props.client.query({
                    query: GET_MULTI_DATE_ATTENDANCE_REPORT,
                    variables: {
                        academic_year_id: parseInt(selectedYear),
                        institute_id: parseInt(Cookies.get("institutionid")),
                        branch_id: parseInt(selectedBranch) || null,
                        // Multi-select from the header filter; when set it wins over branch_id.
                        branch_ids: this.branchScopeCsv(),
                        // class_id is already a String arg the resolver splits on "," —
                        // a CSV needs no schema change here.
                        class_id: classIds,
                        section_id: sectionIds,
                        from_date: String(startDateCalender),
                        to_date: String(endDateCalender),
                        mainSource: this.state.mainSource,
                    },
                    fetchPolicy: "no-cache",
                });
                data = res?.data?.getMultiDateAttendanceReport || [];
            } else if (selected === 2) {
                const res = await this.props.client.query({
                    query: GET_MONTHLY_ATTENDANCE_REPORT,
                    variables: {
                        academic_year_id: parseInt(selectedYear),
                        institute_id: parseInt(Cookies.get("institutionid")),
                        branch_id: parseInt(selectedBranch) || null,
                        // Multi-select from the header filter; when set it wins over branch_id.
                        branch_ids: this.branchScopeCsv(),
                        // class_id here is an Int (legacy single-class callers); class_ids is
                        // the multi-select CSV and wins when supplied.
                        class_id: null,
                        class_ids: classIds,
                        section_id: sectionIds,
                        month: selectedMonthId,
                        mainSource: this.state.mainSource,
                    },
                    fetchPolicy: "no-cache",
                });
                data = res?.data?.getMonthlyAttendanceReport || [];
            } else if (selected === 3 || selected === 10) {
                const classIds = this.state.classSelectedvalue.map((c) => String(c.value)).join(",");
                const sectionIds = this.state.sectionSelectedvalue.map((s) => String(s.value)).join(",");
                const res = await this.props.client.query({
                    query: GET_STUDENT_ATTENDANCE_REPORT_DETAILS,
                    variables: {
                        academic_year_id: parseInt(selectedYear),
                        institute_id: parseInt(Cookies.get("institutionid")),
                        branch_id: parseInt(selectedBranch) || null,
                        // Multi-select from the header filter; when set it wins over branch_id.
                        branch_ids: this.branchScopeCsv(),
                        class_id: classIds,
                        section_id: sectionIds,
                        from_date: String(startDateCalender),
                        to_date: String(endDateCalender),
                        mainSource: this.state.mainSource,
                    },
                    fetchPolicy: "no-cache",
                });
                data = res?.data?.getStudentAttendanceReportDetails || [];
            } else if (selected === 11 || selected === 12) {
                const classIds = this.state.classSelectedvalue.map((c) => String(c.value)).join(",");
                const sectionIds = this.state.sectionSelectedvalue.map((s) => String(s.value)).join(",");
                const studentRes = await this.props.client.query({
                    query: GET_STUDENT_ATTENDANCE_REPORT_DETAILS,
                    variables: {
                        academic_year_id: parseInt(selectedYear),
                        institute_id: parseInt(Cookies.get("institutionid")),
                        branch_id: parseInt(selectedBranch) || null,
                        // Multi-select from the header filter; when set it wins over branch_id.
                        branch_ids: this.branchScopeCsv(),
                        class_id: classIds,
                        section_id: sectionIds,
                        from_date: String(startDateCalender),
                        to_date: String(endDateCalender),
                        mainSource: this.state.mainSource,
                    },
                    fetchPolicy: "no-cache",
                });
                const studentsList = studentRes?.data?.getStudentAttendanceReportDetails || [];

                const fetchLogPromises = studentsList.map(async (student) => {
                    if (!student.admission_no) return [];
                    try {
                        const bioRes = await this.props.client.query({
                            query: GET_STUDENT_BIOMETRIC_LOGS,
                            variables: {
                                admission_no: String(student.admission_no),
                                institute_id: parseInt(Cookies.get("institutionid")),
                            },
                            fetchPolicy: "network-only",
                        });
                        const logs = bioRes?.data?.getStudentBiometricLogs?.logs || [];
                        return logs.map(l => ({
                            ...l,
                            student_name: student.student_name,
                            admission_no: student.admission_no,
                            roll_no: student.roll_no,
                            class_id: student.class_id,
                            section_id: student.section_id,
                            branch_id: student.branch_id
                        }));
                    } catch (err) {
                        return [];
                    }
                });

                const logsArrays = await Promise.all(fetchLogPromises);
                const allPunches = logsArrays.flat().sort((a, b) => {
                    return new Date(b.punch_time) - new Date(a.punch_time);
                });

                if (selected === 11) {
                    data = allPunches;
                } else {
                    const devicesMap = new Map();
                    allPunches.forEach(p => {
                        if (!p.device_id) return;
                        const dev = devicesMap.get(p.device_id) || {
                            id: p.device_id,
                            device_id: p.device_id,
                            total_punches: 0,
                            last_punch_time: null,
                            last_sync_at: null
                        };
                        dev.total_punches++;
                        if (!dev.last_punch_time || new Date(p.punch_time) > new Date(dev.last_punch_time)) {
                            dev.last_punch_time = p.punch_time;
                        }
                        if (p.sync_at && (!dev.last_sync_at || new Date(p.sync_at) > new Date(dev.last_sync_at))) {
                            dev.last_sync_at = p.sync_at;
                        }
                        devicesMap.set(p.device_id, dev);
                    });
                    data = Array.from(devicesMap.values());
                }
            } else if (selected === 4) {
                const classIds = this.state.classSelectedvalue.map((c) => String(c.value)).join(",");
                const sectionIds = this.state.sectionSelectedvalue.map((s) => String(s.value)).join(",");
                // Branch scope is owned upstream (parent prop, else the header multi-select).
                const branchIds = this.branchScopeCsv() || "";
                // const yearIds = this.state.yearSelectedvalue.map((y) => String(y.value)).join(",");
                const monthIds = this.state.monthSelectedvalue.map((m) => m.value).join(",");

                const res = await this.props.client.query({
                    query: GET_CONSOLIDATED_DAYWISE_ATTENDANCE_REPORT,
                    variables: {
                        institute_id: parseInt(Cookies.get("institutionid")),
                        month: monthIds,
                        academic_year_id: parseInt(selectedYear),
                        branch_id: branchIds,
                        class_id: classIds,
                        section_id: sectionIds,
                        mainSource: this.state.mainSource,
                    },
                    fetchPolicy: "no-cache",
                });
                const rawData = res?.data?.getConsolidatedDaywiseAttendanceReport || [];
                data = [...rawData].sort((a, b) => {
                    const classA = String(a.class_name || this.resolveClassName(a.class_id) || "");
                    const classB = String(b.class_name || this.resolveClassName(b.class_id) || "");
                    return classA.localeCompare(classB, undefined, { numeric: true, sensitivity: "base" });
                });
            } else if (selected === 5) {
                const classIds = this.state.classSelectedvalue.map((c) => String(c.value)).join(",");
                const sectionIds = this.state.sectionSelectedvalue.map((s) => String(s.value)).join(",");
                // Branch scope is owned upstream (parent prop, else the header multi-select).
                const branchIds = this.branchScopeCsv() || "";
                const res = await this.props.client.query({
                    query: GET_PERIODWISE_ATTENDANCE_REPORT,
                    variables: {
                        academic_year_id: parseInt(selectedYear),
                        institute_id: parseInt(Cookies.get("institutionid")),
                        branch_id: branchIds,
                        class_id: classIds,
                        section_id: sectionIds,
                        month: selectedMonthId,
                    },
                    fetchPolicy: "no-cache",
                });
                const rawData = res?.data?.getPeriodwiseAttendanceReport || [];
                data = [...rawData].sort((a, b) => {
                    const classA = String(a.class_name || this.resolveClassName(a.class_id) || "");
                    const classB = String(b.class_name || this.resolveClassName(b.class_id) || "");
                    return classA.localeCompare(classB, undefined, { numeric: true, sensitivity: "base" });
                });
            }
            this.setState({
                attendanceReport: data,
                isClassFilterLoader: 0,
                hasSearched: true,
                periodWiseSearch: "",
                periodWisePage: 1,
                consolidated4Search: "",
                consolidated4Page: 1,
            });
        } catch (err) {
            console.error(err);
            this.setState({ isClassFilterLoader: 0 });
        }
    };


    autoFetchIfReady = () => {
        const { selected, selectedYear, selectedBranch, selectedClass, selectedSection, selectedMonthId, classSelectedvalue, sectionSelectedvalue, branchSelectedvalue } = this.state;
        if (!selectedYear) return;
        if (selected === 4 || selected === 5) {
            if (!this.hasBranchSelection() || !classSelectedvalue.length || !sectionSelectedvalue.length) return;
            if (!selectedMonthId) return;
        } else {
            if (!this.hasBranchSelection()) return;
            if (!classSelectedvalue.length || !sectionSelectedvalue.length) return;
            if (selected === 2 && !selectedMonthId) return;
        }
        this.handleClassWiseReportSubmit();
    };

    downloadExcel = () => {
        const { attendanceReport, selected } = this.state;
        if (!attendanceReport.length) return;

        const FILTER_LABELS = { 1: "Class Wise", 2: "Monthly Wise", 3: "Student Wise", 4: "Consolidated", 5: "Period Wise" };
        let sheetData = [];

        if (selected === 1) {
            sheetData = [
                ["S.No", "Branch", "Class", "Section", "Date", "Total Students", "Present", "Absent", "Percentage (%)"],
                ...attendanceReport.map((r, i) => [
                    i + 1,
                    this.resolveBranchName(r.branch_id),
                    this.resolveClassName(r.class_id),
                    this.resolveSectionName(r.section_id),
                    fmtDMY(r.att_date),
                    r.total_students,
                    r.present,
                    r.absent,
                    r.percentage,
                ]),
            ];
        } else if (selected === 2) {
            const dayHeaders = attendanceReport.length > 0
                ? [...(attendanceReport[0].days || [])].sort((a, b) => a.day - b.day).map(d => `Day ${d.day}`)
                : [];
            sheetData = [
                [
                    "S.No",
                    "Roll No",
                    "Student Name",
                    // "Date of Birth",
                    "Father Name",
                    // "Mother Name",
                    // "Father Mobile",
                    "Branch",
                    "Class",
                    "Section",
                    "Working Days",
                    "Total Present (%)",
                    "Total Absent (%)",
                    "Percentage (%)",
                    ...dayHeaders
                ],
                ...attendanceReport.map((r, i) => {
                    const dayCells = [...(r.days || [])].sort((a, b) => a.day - b.day).map(d => d.status ?? "-");
                    const wd = parseInt(r.total_working_days) || 0;
                    return [
                        i + 1,
                        r.roll_no,
                        r.student_name,
                        // r.dob ?? "-",
                        r.father_name ?? "-",
                        // r.mother_name ?? "-",
                        // r.father_phone ?? "-",
                        this.resolveBranchName(r.branch_id),
                        this.resolveClassName(r.class_id),
                        this.resolveSectionName(r.section_id),
                        r.total_working_days,
                        wd ? ((parseInt(r.total_present) || 0) / wd * 100).toFixed(1) + "%" : "-",
                        wd ? ((parseInt(r.total_absent) || 0) / wd * 100).toFixed(1) + "%" : "-",
                        r.percentage,
                        ...dayCells,
                    ];
                }),
            ];
        } else if (selected === 3) {
            sheetData = [
                [
                    "S.No",
                    "Roll No",
                    "Student Name",
                    // "Date of Birth",
                    "Father Name",
                    // "Mother Name",
                    // "Father Mobile",
                    "Branch",
                    "Class",
                    "Section",
                    "Working Days",
                    "Present",
                    "Absent",
                    "Not Marked",
                    "Attendance %"
                ],
                ...attendanceReport.map((r, i) => [
                    i + 1,
                    r.roll_no,
                    r.student_name,
                    // r.dob ?? "-",
                    r.father_name ?? "-",
                    // r.mother_name ?? "-",
                    // r.father_phone ?? "-",
                    this.resolveBranchName(r.branch_id),
                    this.resolveClassName(r.class_id),
                    this.resolveSectionName(r.section_id),
                    r.working_days,
                    r.present,
                    r.absent,
                    r.not_marked,
                    r.attendance_percentage,
                ]),
            ];
        } else if (selected === 4) {
            const allDates = [];
            const seenDates = new Set();
            attendanceReport.forEach(row => {
                (row.dateWiseData || []).forEach(d => {
                    if (!seenDates.has(d.date)) { seenDates.add(d.date); allDates.push(d.date); }
                });
            });
            allDates.sort();
            sheetData = [
                ["Sr No.", "Branch", "Class", "Section", ...allDates.flatMap(d => [`${d} Present`, `${d} Absent`, `${d} Total`])],
                ...attendanceReport.map((row, idx) => {
                    const dateMap = {};
                    (row.dateWiseData || []).forEach(d => { dateMap[d.date] = d; });
                    return [
                        row.sr_no ?? idx + 1,
                        this.resolveBranchName(row.branch_id),
                        row.class_name || this.resolveClassName(row.class_id),
                        this.resolveSectionName(row.section_id),
                        ...allDates.flatMap(date => {
                            const d = dateMap[date];
                            return d ? [d.present ?? "-", d.absent ?? "-", d.total ?? "-"] : ["-", "-", "-"];
                        }),
                    ];
                }),
            ];
        } else if (selected === 5) {
            const dateColumns = this.buildPeriodWiseDateColumns(attendanceReport);
            const periodHeaders = [];
            dateColumns.forEach((d) => {
                for (let p = 1; p <= d.periodCount; p++) {
                    const periodLabel = d.periodLabels?.[p - 1] || `P${p}`;
                    periodHeaders.push(`${d.dateLabel} ${periodLabel}`);
                }
            });
            sheetData = [
                [
                    "S.No",
                    "Roll No",
                    "Student Name",
                    // "Date of Birth",
                    "Father Name",
                    // "Mother Name",
                    // "Father Mobile",
                    "Branch",
                    "Class",
                    "Section",
                    ...periodHeaders
                ],
                ...attendanceReport.map((row, idx) => {
                    const dateMap = {};
                    (row.dateWiseData || []).forEach((d) => { dateMap[d.date] = d; });
                    const periodCells = [];
                    dateColumns.forEach((d) => {
                        const dayData = dateMap[d.date];
                        for (let p = 1; p <= d.periodCount; p++) {
                            const period = (dayData?.periods || []).find((x) => +x.period_no === p);
                            periodCells.push(
                                dayData?.is_holiday ? "H" : (period?.status ?? "-")
                            );
                        }
                    });
                    return [
                        row.sr_no ?? idx + 1,
                        row.roll_no ?? "-",
                        row.student_name ?? "-",
                        // row.dob ?? "-",
                        row.father_name ?? "-",
                        // row.mother_name ?? "-",
                        // row.father_phone ?? "-",
                        this.resolveBranchName(row.branch_id),
                        this.resolveClassName(row.class_id),
                        this.resolveSectionName(row.section_id),
                        ...periodCells,
                    ];
                }),
            ];
        }

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, FILTER_LABELS[selected]);
        XLSX.writeFile(workbook, `attendance_report_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    getLogoDataUrl = async (logoFile) => {
        if (!logoFile) return "";
        const url = logoFile.startsWith("http")
            ? logoFile
            : `https://support.rizee.in/files/${logoFile}`;
        try {
            const res = await fetch(url, { credentials: "include" });
            if (!res.ok) return url;
            const blob = await res.blob();
            return await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = () => resolve(url);
                reader.readAsDataURL(blob);
            });
        } catch {
            return url;
        }
    };

    loadOrgProfile = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_ORGANISATION_PROFILE,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            const data = result.data?.getOrganisationProfile;
            const profile = {
                organisation_name: data?.organisation_name || "",
                logo: data?.logo || "",
                complete_address: data?.complete_address || "",
            };
            this.setState({ orgProfile: profile });
            return profile;
        } catch (err) {
            console.error("loadOrgProfile error:", err);
            return this.state.orgProfile;
        }
    };

    printReport = async () => {
        const { attendanceReport, selected } = this.state;

        if (!attendanceReport.length) return;

        let orgProfile = this.state.orgProfile || {};
        if (!orgProfile.logo) {
            orgProfile = (await this.loadOrgProfile()) || orgProfile;
        }

        const instituteName =
            Cookies.get("institutename") || "";

        const instituteShortName =
            instituteName
                .split(" ")
                .map((word) => word[0])
                .join("")
                .toUpperCase()
                .slice(0, 2);

        let html = "";
        const thStyle = `style="background:#4f46e5;color:#fff;font-weight:700;font-size:12px;padding:8px 6px;text-align:center;border:1px solid #ccc;"`;
        const tdStyle = `style="padding:7px 6px;text-align:center;border:1px solid #ccc;font-size:12px;"`;

        const orgName = orgProfile.organisation_name || "";
        const logoFile = orgProfile.logo || "";
        const orgAddress = orgProfile.complete_address || "";
        const logoSrc = logoFile ? await this.getLogoDataUrl(logoFile) : "";

        const FILTER_LABELS = { 1: "Class Wise", 2: "Monthly Wise", 3: "Student Wise", 4: "Consolidated", 5: "Period Wise" };

        if (selected === 1) {
            html = `<table><thead><tr>
                <th ${thStyle}>S.No</th><th ${thStyle}>Branch</th><th ${thStyle}>Class</th><th ${thStyle}>Section</th><th ${thStyle}>Date</th>
                <th ${thStyle}>Total Students</th><th ${thStyle}>Present</th><th ${thStyle}>Absent</th><th ${thStyle}>Percentage (%)</th>
            </tr></thead><tbody>${attendanceReport.map((r, i) =>
                `<tr><td ${tdStyle}>${i + 1}</td><td ${tdStyle}>${this.resolveBranchName(r.branch_id)}</td><td ${tdStyle}>${this.resolveClassName(r.class_id)}</td>
                    <td ${tdStyle}>${this.resolveSectionName(r.section_id)}</td><td ${tdStyle}>${r.att_date ? fmtDMY(r.att_date) : "-"}</td>
                    <td ${tdStyle}>${r.total_students ?? "-"}</td><td ${tdStyle}>${r.present ?? "-"}</td><td ${tdStyle}>${r.absent ?? "-"}</td><td ${tdStyle}>${r.percentage ?? "-"}</td></tr>`
            ).join("")}</tbody></table>`;
        } else if (selected === 2) {
            const dayHeaders = attendanceReport.length > 0
                ? [...(attendanceReport[0].days || [])].sort((a, b) => a.day - b.day).map(d => `<th ${thStyle}>${d.day}</th>`).join("")
                : "";
            html = `<table><thead><tr>
                <th ${thStyle}>S.No</th><th ${thStyle}>Roll No</th><th ${thStyle}>Student Name</th>
                <!-- <th ${thStyle}>Date of Birth</th> --> <th ${thStyle}>Father Name</th>
                <!-- <th ${thStyle}>Mother Name</th> --><!-- <th ${thStyle}>Father Mobile</th> -->
                <th ${thStyle}>Branch</th><th ${thStyle}>Class</th><th ${thStyle}>Section</th>
                <th ${thStyle}>Working Days</th><th ${thStyle}>Total Present (%)</th><th ${thStyle}>Total Absent (%)</th><th ${thStyle}>%</th>${dayHeaders}
            </tr></thead><tbody>${attendanceReport.map((r, i) => {
                const dayCells = [...(r.days || [])].sort((a, b) => a.day - b.day).map(d => `<td ${tdStyle}>${d.status ?? "-"}</td>`).join("");
                const wd = parseInt(r.total_working_days) || 0;
                const presPct = wd ? ((parseInt(r.total_present) || 0) / wd * 100).toFixed(1) + "%" : "-";
                const absPct = wd ? ((parseInt(r.total_absent) || 0) / wd * 100).toFixed(1) + "%" : "-";
                return `<tr><td ${tdStyle}>${i + 1}</td><td ${tdStyle}>${r.roll_no ?? "-"}</td><td ${tdStyle}>${r.student_name ?? "-"}</td>
                    <!-- <td ${tdStyle}>${r.dob ?? "-"}</td> --> <td ${tdStyle}>${r.father_name ?? "-"}</td><!-- <td ${tdStyle}>${r.mother_name ?? "-"}</td> --><!-- <td ${tdStyle}>${r.father_phone ?? "-"}</td> -->
                    <td ${tdStyle}>${this.resolveBranchName(r.branch_id)}</td><td ${tdStyle}>${this.resolveClassName(r.class_id)}</td>
                    <td ${tdStyle}>${this.resolveSectionName(r.section_id)}</td>
                    <td ${tdStyle}>${r.total_working_days ?? "-"}</td><td ${tdStyle}>${presPct}</td><td ${tdStyle}>${absPct}</td>
                    <td ${tdStyle}>${r.percentage ?? "-"}</td>${dayCells}</tr>`;
            }).join("")}</tbody></table>`;
        } else if (selected === 3) {
            html = `<table><thead><tr>
                <th ${thStyle}>S.No</th><th ${thStyle}>Roll No</th><th ${thStyle}>Student Name</th>
                <!-- <th ${thStyle}>Date of Birth</th> --> <th ${thStyle}>Father Name</th><!-- <th ${thStyle}>Mother Name</th> --><!-- <th ${thStyle}>Father Mobile</th> -->
                <th ${thStyle}>Branch</th><th ${thStyle}>Class</th><th ${thStyle}>Section</th>
                <th ${thStyle}>Working Days</th><th ${thStyle}>Present</th><th ${thStyle}>Absent</th><th ${thStyle}>Not Marked</th><th ${thStyle}>Attendance %</th>
            </tr></thead><tbody>${attendanceReport.map((r, i) =>
                `<tr><td ${tdStyle}>${i + 1}</td><td ${tdStyle}>${r.roll_no ?? "-"}</td><td ${tdStyle}>${r.student_name ?? "-"}</td>
                <!-- <td ${tdStyle}>${r.dob ?? "-"}</td> --> <td ${tdStyle}>${r.father_name ?? "-"}</td><!-- <td ${tdStyle}>${r.mother_name ?? "-"}</td> --><!-- <td ${tdStyle}>${r.father_phone ?? "-"}</td> -->
                <td ${tdStyle}>${this.resolveBranchName(r.branch_id)}</td><td ${tdStyle}>${this.resolveClassName(r.class_id)}</td><td ${tdStyle}>${this.resolveSectionName(r.section_id)}</td>
                <td ${tdStyle}>${r.working_days ?? "-"}</td><td ${tdStyle}>${r.present ?? "-"}</td><td ${tdStyle}>${r.absent ?? "-"}</td>
                <td ${tdStyle}>${r.not_marked ?? "-"}</td><td ${tdStyle}>${r.attendance_percentage ?? "-"}</td></tr>`
            ).join("")}</tbody></table>`;
        } else if (selected === 4) {
            html = this.buildConsolidated4PrintHtml(thStyle, tdStyle);
        } else if (selected === 5) {
            html = this.buildPeriodWisePrintHtml(thStyle, tdStyle);
        }

        const printDate = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });
        // const logoHtml = `<div style="display:inline-flex;align-items:center;justify-content:center;gap:14px;">
        //     <div style="width:56px;height:56px;background:linear-gradient(135deg,#6366f1,#4f46e5);border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:900;font-size:22px;box-shadow:0 3px 10px rgba(79,70,229,0.45);flex-shrink:0;">${instituteShortName}</div>
        //     <div style="text-align:left;">
        //         <div style="font-size:24px;font-weight:900;color:#1f2937;letter-spacing:3px;">${instituteName}</div>
        //         <div style="font-size:11px;color:#6b7280;letter-spacing:1px;margin-top:2px;">Student Attendance Management System</div>
        //     </div>
        // </div>`;

        const logoHtml = `
<div style="display:flex;align-items:center;justify-content:center;gap:14px;">
    
    ${logoSrc ? `
        <img
            class="print-logo"
            src="${logoSrc}"
            alt="logo"
            style="width:60px;height:60px;object-fit:contain;flex-shrink:0;"
        />
    ` : instituteShortName ? `
        <div style="width:56px;height:56px;background:linear-gradient(135deg,#6366f1,#4f46e5);border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:900;font-size:22px;flex-shrink:0;">
            ${instituteShortName}
        </div>
    ` : ""}

    <div style="text-align:left;">
        <div style="
            font-size:22px;
            font-weight:700;
            color:#111827;
        ">
            ${orgName || instituteName}
        </div>

        <div style="
            font-size:11px;
            color:#6b7280;
            margin-top:3px;
        ">
            ${orgAddress || ""}
        </div>
    </div>
</div>
`;

        const printWindow = window.open("", "_blank");
        if (!printWindow) return;

        printWindow.document.write(`<html><head><title>Attendance Report - ${FILTER_LABELS[selected]}</title>
            <style>
            body{font-family:Arial,sans-serif;font-size:12px;padding:24px;}
            table{border-collapse:collapse;width:100%;}
            .header-center{text-align:center;padding-bottom:14px;margin-bottom:14px;border-bottom:2.5px solid #4f46e5;}
            .sub-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;padding-bottom:10px;border-bottom:1px solid #e5e7eb;}
            .report-title{font-weight:700;color:#4f46e5;font-size:15px;}
            .report-date{color:#374151;font-size:13px;}
            @media print{
                body{padding:8px;}
                ${selected === 2 ? `
                @page{size:A4 landscape;margin:4mm;}
                body{font-size:8px;padding:0;margin:0;}
                table{width:100% !important;zoom:58%;-moz-transform:scale(0.58);-moz-transform-origin:0 0;}
                table td,table th{padding:2px 1.5px !important;font-size:8px !important;white-space:nowrap;}
                table thead{display:table-header-group;}
                ` : ''}
                ${selected === 4 ? `
                @page{size:A4 landscape;margin:8mm;}
                body{font-size:9px;}
                table td,table th{padding:3px 2px !important;font-size:8px !important;}
                ` : ''}
                ${selected === 4 ? `
                .cons4-page{page-break-after:always;}
                .cons4-page:last-child{page-break-after:auto;}
                .cons4-page-label{text-align:right;font-size:10px;color:#6b7280;margin:4px 0 8px;font-weight:600;}
                .cons4-table thead{display:table-header-group;}
                .cons4-table tr{page-break-inside:avoid;}
                .cons4-table tbody tr{page-break-after:auto;}
                ` : ''}
                ${selected === 5 ? `
                @page{size:A4 landscape;margin:8mm;}
                body{font-size:9px;}
                table td,table th{padding:3px 2px !important;font-size:8px !important;}
                ` : ''}
                ${selected === 5 ? `
                .print-page{page-break-after:always;}
                .print-page:last-child{page-break-after:auto;}
                .print-page-label{text-align:right;font-size:10px;color:#6b7280;margin:4px 0 8px;font-weight:600;}
                .period-wise-print-table thead{display:table-header-group;}
                .period-wise-print-table tr{page-break-inside:avoid;}
                .period-wise-print-table tbody tr{page-break-after:auto;}
                ` : ''}
            }
            ${selected === 4 ? `
            .cons4-page{margin-bottom:24px;}
            .cons4-page-label{text-align:right;font-size:11px;color:#6b7280;margin:4px 0 8px;font-weight:600;}
            ` : ''}
            ${selected === 5 ? `
            .print-page{margin-bottom:24px;}
            .print-page-label{text-align:right;font-size:11px;color:#6b7280;margin:4px 0 8px;font-weight:600;}
            ` : ''}
            </style></head>
            <body>
            <div class="header-center">${logoHtml}</div>
            <div class="sub-header">
                <div class="report-title">Student Attendance Report &mdash; ${FILTER_LABELS[selected]}</div>
                <div class="report-date">Date: ${printDate}</div>
            </div> 
            ${html}
            <script>
                (function () {
                    var img = document.querySelector(".print-logo");
                    function doPrint() {
                        window.focus();
                        window.onafterprint = function () { window.close(); };
                        window.print();
                    }
                    if (img && !img.complete) {
                        img.onload = doPrint;
                        img.onerror = doPrint;
                    } else {
                        setTimeout(doPrint, 100);
                    }
                })();
            <\/script>
            </body></html>`);
        printWindow.document.close();
        printWindow.focus();
    };

    selected1Columns = [
        {
            dataField: "sno",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "branch_id",
            text: "Branch",
            sort: true,
            formatter: (cell) => this.resolveBranchName(cell),
        },
        {
            dataField: "class_id",
            text: "Class",
            sort: true,
            formatter: (cell) => this.resolveClassName(cell),
        },
        {
            dataField: "section_id",
            text: "Section",
            sort: true,
            formatter: (cell) => this.resolveSectionName(cell),
        },
        {
            dataField: "att_date",
            text: "Date",
            sort: true,
            // Arrives as "2026-07-17" from DATE(FROM_UNIXTIME(...)); show it as DD/MM/YYYY.
            // sort stays on the raw ISO value, which sorts correctly as a string.
            formatter: (cell) => fmtDMY(cell),
        },
        {
            dataField: "total_students",
            text: "Total Students",
            formatter: (cell) => this.badgeFormatter(cell, "#4169e1"),
        },
        {
            dataField: "present",
            text: "Present",
            formatter: (cell) => this.badgeFormatter(cell, "#37c978"),
        },
        {
            dataField: "absent",
            text: "Absent",
            formatter: (cell) => this.badgeFormatter(cell, "#e11d48"),
        },
        {
            dataField: "percentage",
            text: "Percentage (%)",
            formatter: (cell) => this.attendanceFormatter(cell),
        },
    ]

    selected2Columns = [
        {
            dataField: "sno",
            text: "S.No",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
            style: { width: 55, minWidth: 55 },
            headerStyle: { width: 55, minWidth: 55, background: "#fff", color: "#1f2937" },
        },
        {
            dataField: "roll_no",
            text: "Roll No",
            sort: true,
            style: { width: 80, minWidth: 80 },
            headerStyle: { width: 80, minWidth: 80, background: "#fff", color: "#1f2937" },
            formatter: (cell) => cell ? cell : "-"
        },
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
            style: { width: 180, minWidth: 180 },
            headerStyle: { width: 180, minWidth: 180, background: "#fff", color: "#1f2937" },
            formatter: (cell) => cell ? cell : "-"
        },
        // {
        //     dataField: "dob",
        //     text: "Date of Birth",
        //     sort: true,
        //     style: { width: 180, minWidth: 180 },
        //     headerStyle: { width: 180, minWidth: 180, background: "#fff", color: "#1f2937" },
        //     formatter: (cell) => cell ? cell : "-"
        // },
        {
            dataField: "father_name",
            text: "Father Name",
            sort: true,
            style: { width: 180, minWidth: 180 },
            headerStyle: { width: 180, minWidth: 180, background: "#fff", color: "#1f2937" },
            formatter: (cell) => cell ? cell : "-"
        },
        // {
        //     dataField: "mother_name",
        //     text: "Mother Name",
        //     sort: true,
        //     style: { width: 180, minWidth: 180 },
        //     headerStyle: { width: 180, minWidth: 180, background: "#fff", color: "#1f2937" },
        //     formatter: (cell) => cell ? cell : "-"
        // },
        // {
        //     dataField: "father_phone",
        //     text: "Father Mobile",
        //     sort: true,
        //     style: { width: 180, minWidth: 180 },
        //     headerStyle: { width: 180, minWidth: 180, background: "#fff", color: "#1f2937" },
        //     formatter: (cell) => cell ? cell : "-"
        // },
        {
            dataField: "branch_id",
            text: "Branch",
            sort: true,
            style: { width: 110, minWidth: 110 },
            headerStyle: { width: 110, minWidth: 110, background: "#fff", color: "#1f2937" },
            formatter: (cell) => this.resolveBranchName(cell),
        },
        {
            dataField: "class_id",
            text: "Class",
            sort: true,
            style: { width: 100, minWidth: 100 },
            headerStyle: { width: 100, minWidth: 100, background: "#fff", color: "#1f2937" },
            formatter: (cell) => this.resolveClassName(cell),
        },
        {
            dataField: "section_id",
            text: "Section",
            sort: true,
            style: { width: 100, minWidth: 100 },
            headerStyle: { width: 100, minWidth: 100, background: "#fff", color: "#1f2937" },
            formatter: (cell) => this.resolveSectionName(cell),
        },
        {
            dataField: "total_working_days",
            text: "Working Days",
            formatter: (cell) => this.badgeFormatter(cell, "#4169e1"),
            style: { width: 105, minWidth: 105 },
            headerStyle: { width: 105, minWidth: 105, background: "#fff", color: "#1f2937" },
        },
        {
            dataField: "total_present",
            text: "Total Present (%)",
            formatter: (cell, row) => {
                const wd = parseInt(row.total_working_days) || 0;
                const pct = wd ? ((parseInt(cell) || 0) / wd * 100).toFixed(1) + "%" : "-";
                return this.badgeFormatter(pct, "#37c978");
            },
            style: { width: 105, minWidth: 105 },
            headerStyle: { width: 105, minWidth: 105, background: "#fff", color: "#1f2937" },
        },
        {
            dataField: "total_absent",
            text: "Total Absent (%)",
            formatter: (cell, row) => {
                const wd = parseInt(row.total_working_days) || 0;
                const pct = wd ? ((parseInt(cell) || 0) / wd * 100).toFixed(1) + "%" : "-";
                return this.badgeFormatter(pct, "#e11d48");
            },
            style: { width: 105, minWidth: 105 },
            headerStyle: { width: 105, minWidth: 105, background: "#fff", color: "#1f2937" },
        },
        {
            dataField: "percentage",
            text: "Percentage (%)",
            formatter: (cell) => this.attendanceFormatter(cell),
            style: { width: 115, minWidth: 115 },
            headerStyle: { width: 115, minWidth: 115, background: "#fff", color: "#1f2937" },
        },
    ]

    // ── Biometric punch logs (Student Wise → click a student name) ──────────
    openBiometricLogs = async (row) => {
        if (!row) return;
        this.setState({
            selectedReportStudent: row,
            detailsLoading: true,
            detailsError: "",
            bioLogs: [],
            manualLogs: []
        });

        try {
            let bioLogs = [];
            if (row.admission_no) {
                const bioRes = await this.props.client.query({
                    query: GET_STUDENT_BIOMETRIC_LOGS,
                    variables: {
                        admission_no: String(row.admission_no),
                        institute_id: parseInt(Cookies.get("institutionid")),
                    },
                    fetchPolicy: "network-only",
                });
                if (bioRes?.data?.getStudentBiometricLogs?.logs) {
                    bioLogs = bioRes.data.getStudentBiometricLogs.logs;
                }
            }

            const studentId = parseInt(row.id);
            let manualLogs = [];
            if (studentId) {
                const manualRes = await this.props.client.query({
                    query: GET_MARKED_STUDENT_ATTENDANCE,
                    variables: {
                        edu_student_id: studentId
                    },
                    fetchPolicy: "network-only"
                });
                if (manualRes?.data?.getMarkedStudentAttendance) {
                    manualLogs = manualRes.data.getMarkedStudentAttendance;
                }
            }

            this.setState({
                bioLogs,
                manualLogs,
                detailsLoading: false
            });
        } catch (e) {
            console.error("Error loading logs:", e);
            this.setState({
                detailsLoading: false,
                detailsError: "Failed to load sync details log."
            });
        }
    };

    renderDetailsContainer = () => {
        const { selectedReportStudent, detailsLoading, bioLogs, manualLogs, detailsError } = this.state;
        if (!selectedReportStudent) return null;

        const hasBio = bioLogs && bioLogs.length > 0;
        const showManualSection = this.state.mainSource !== "biometric";
        const showBiometricSection = this.state.mainSource !== "manual" && hasBio;
        const colSpan = (showManualSection && showBiometricSection) ? 6 : 12;

        const statusStyle = (status) => {
            const s = String(status).toUpperCase();
            if (s === "PRESENT" || s === "1") return { background: "#dcfce7", color: "#15803d", padding: "4px 10px", borderRadius: "12px", fontWeight: "700", fontSize: "12px", display: "inline-block" };
            if (s === "ABSENT" || s === "0") return { background: "#fee2e2", color: "#b91c1c", padding: "4px 10px", borderRadius: "12px", fontWeight: "700", fontSize: "12px", display: "inline-block" };
            if (s === "SICK" || s === "3") return { background: "#fef3c7", color: "#b45309", padding: "4px 10px", borderRadius: "12px", fontWeight: "700", fontSize: "12px", display: "inline-block" };
            return { background: "#f3f4f6", color: "#374151", padding: "4px 10px", borderRadius: "12px", fontWeight: "700", fontSize: "12px", display: "inline-block" };
        };

        const punchStyle = (t) => {
            const type = String(t).toUpperCase();
            return {
                display: "inline-block", minWidth: 46, textAlign: "center",
                padding: "2px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                color: "#fff", background: type === "IN" ? "#37c978" : type === "OUT" ? "#e11d48" : "#94a3b8",
            };
        };

        return (
            <div style={{
                background: "#ffffff",
                borderRadius: "18px",
                padding: "24px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
                marginTop: "24px",
                border: "1px solid #e2e8f0"
            }}>
                <div style={{ display: "flex", justifycontent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "10px" }}>
                    <div>
                        <h5 style={{ margin: 0, fontWeight: "700", color: "#0f172a" }}>
                            Synced Logs Audit &mdash; {selectedReportStudent.student_name}
                        </h5>
                        <span style={{ fontSize: "13px", color: "#64748b" }}>
                            Roll No: {selectedReportStudent.roll_no || "-"} | Admission No: {selectedReportStudent.admission_no || "-"}
                        </span>
                    </div>
                    <Button 
                        variant="light" 
                        onClick={() => this.setState({ selectedReportStudent: null, bioLogs: [], manualLogs: [] })}
                        style={{ border: "1px solid #cbd5e1", borderRadius: "8px", fontWeight: "600", fontSize: "13px" }}
                    >
                        <i className="fa fa-times mr-1" /> Close Audit
                    </Button>
                </div>

                {detailsLoading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary spinner-border-sm mr-2" />
                        <span className="text-muted" style={{ fontSize: "14px" }}>Loading logs sync status...</span>
                    </div>
                ) : detailsError ? (
                    <div className="alert alert-danger" style={{ borderRadius: "10px" }}>{detailsError}</div>
                ) : (
                    <Row>
                        {/* Manual Logs Column */}
                        {showManualSection && (
                            <Col md={colSpan} sm={12} className="mb-4">
                                <div style={{ background: "#f8fafc", padding: "16px", borderRadius: "12px", border: "1px solid #e2e8f0", height: "100%" }}>
                                    <h6 style={{ fontWeight: "700", color: "#334155", marginBottom: "14px", display: "flex", alignItems: "center", gap: "6px" }}>
                                        <i className="fa fa-user-edit text-primary" /> Manual Attendance History
                                    </h6>
                                    {manualLogs.length === 0 ? (
                                        <div className="text-center py-4 text-muted" style={{ fontSize: "13px" }}>No manual entries marked for this student.</div>
                                    ) : (
                                        <div style={{ overflowX: "auto" }}>
                                            <Table hover borderless style={{ margin: 0, fontSize: "13px" }}>
                                                <thead>
                                                    <tr style={{ borderBottom: "2px solid #e2e8f0", color: "#475569", fontWeight: "700" }}>
                                                        <th style={{ padding: "8px" }}>#</th>
                                                        <th style={{ padding: "8px" }}>Date</th>
                                                        <th style={{ padding: "8px" }}>Status</th>
                                                        <th style={{ padding: "8px" }}>Marked By</th>
                                                        <th style={{ padding: "8px" }}>Comments</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {manualLogs.map((l, i) => (
                                                        <tr key={l.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                                                            <td style={{ padding: "8px", verticalAlign: "middle" }}>{i + 1}</td>
                                                            <td style={{ padding: "8px", verticalAlign: "middle", fontWeight: "600" }}>
                                                                {l.date ? fmtDMY(l.date) : "—"}
                                                            </td>
                                                            <td style={{ padding: "8px", verticalAlign: "middle" }}>
                                                                <span style={statusStyle(l.attended_status_name || l.attended_status)}>
                                                                    {l.attended_status_name || (l.attended_status === 1 ? "Present" : l.attended_status === 3 ? "Sick" : "Absent")}
                                                                </span>
                                                            </td>
                                                            <td style={{ padding: "8px", verticalAlign: "middle", color: "#64748b" }}>
                                                                {l.inserted_by ? `Admin (ID: ${l.inserted_by})` : "System"}
                                                            </td>
                                                            <td style={{ padding: "8px", verticalAlign: "middle", color: "#64748b" }}>
                                                                {l.comments || "—"}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        )}

                        {/* Biometric logs Column (Conditional) */}
                        {showBiometricSection && (
                            <Col md={colSpan} sm={12} className="mb-4">
                                <div style={{ background: "#f8fafc", padding: "16px", borderRadius: "12px", border: "1px solid #e2e8f0", height: "100%" }}>
                                    <h6 style={{ fontWeight: "700", color: "#334155", marginBottom: "14px", display: "flex", alignItems: "center", gap: "6px" }}>
                                        <i className="fa fa-fingerprint text-success" /> Biometric Punch Logs
                                    </h6>
                                    <div style={{ overflowX: "auto" }}>
                                        <Table hover borderless style={{ margin: 0, fontSize: "13px" }}>
                                            <thead>
                                                <tr style={{ borderBottom: "2px solid #e2e8f0", color: "#475569", fontWeight: "700" }}>
                                                    <th style={{ padding: "8px" }}>#</th>
                                                    <th style={{ padding: "8px" }}>Punch Type</th>
                                                    <th style={{ padding: "8px" }}>Punch Time</th>
                                                    <th style={{ padding: "8px" }}>Device</th>
                                                    <th style={{ padding: "8px" }}>Sync Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bioLogs.map((l, i) => (
                                                    <tr key={l.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                                                        <td style={{ padding: "8px", verticalAlign: "middle" }}>{i + 1}</td>
                                                        <td style={{ padding: "8px", verticalAlign: "middle" }}>
                                                            <span style={punchStyle(l.punch_type)}>{l.punch_type || "—"}</span>
                                                        </td>
                                                        <td style={{ padding: "8px", verticalAlign: "middle", fontWeight: "600" }}>
                                                            {l.punch_time ? fmtDMYTime(l.punch_time) : "—"}
                                                        </td>
                                                        <td style={{ padding: "8px", verticalAlign: "middle", color: "#64748b" }}>
                                                            {l.device_id || "—"}
                                                        </td>
                                                        <td style={{ padding: "8px", verticalAlign: "middle", color: "#64748b" }}>
                                                            {l.sync_at ? fmtDMYTime(l.sync_at) : "—"}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                )}
            </div>
        );
    };

    selected3Columns = [
        {
            dataField: "sno",
            text: "S.No",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "roll_no",
            text: "Roll No",
            sort: true,
        },
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
            formatter: (cell, row) => (
                <span
                    onClick={() => this.openBiometricLogs(row)}
                    title="View biometric logs"
                    style={{ color: "#4f46e5", fontWeight: 600, cursor: "pointer", textDecoration: "underline" }}
                >
                    {cell || "-"}
                </span>
            ),
        },
        {
            dataField: "father_name",
            text: "Father Name",
            sort: true,
            style: { width: 180, minWidth: 180 },
            headerStyle: { width: 180, minWidth: 180, background: "#fff", color: "#1f2937" },
            formatter: (cell) => cell ? cell : "-"
        },
        {
            dataField: "branch_id",
            text: "Branch",
            sort: true,
            formatter: (cell) => this.resolveBranchName(cell),
        },
        {
            dataField: "class_id",
            text: "Class",
            sort: true,
            formatter: (cell) => this.resolveClassName(cell),
        },
        {
            dataField: "section_id",
            text: "Section",
            sort: true,
            formatter: (cell) => this.resolveSectionName(cell),
        },
        {
            dataField: "working_days",
            text: "Working Days",
            formatter: (cell) => this.badgeFormatter(cell, "#4169e1"),
        },
        {
            dataField: "present",
            text: "Present",
            formatter: (cell) => this.badgeFormatter(cell, "#37c978"),
        },
        {
            dataField: "absent",
            text: "Absent",
            formatter: (cell) => this.badgeFormatter(cell, "#e11d48"),
        },
        {
            dataField: "not_marked",
            text: "Not Marked",
            formatter: (cell) => this.badgeFormatter(cell, "#f59e0b"),
        },
        {
            dataField: "attendance_percentage",
            text: "Attendance %",
            formatter: (cell) => this.attendanceFormatter(cell),
        },
    ];

    selected10Columns = [
        {
            dataField: "sno",
            text: "S.No",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "roll_no",
            text: "Roll No",
            sort: true,
        },
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
            formatter: (cell, row) => (
                <span
                    onClick={() => this.openBiometricLogs(row)}
                    title="View biometric logs"
                    style={{ color: "#4f46e5", fontWeight: 600, cursor: "pointer", textDecoration: "underline" }}
                >
                    {cell || "-"}
                </span>
            ),
        },
        {
            dataField: "father_name",
            text: "Father Name",
            sort: true,
            style: { width: 180, minWidth: 180 },
            headerStyle: { width: 180, minWidth: 180, background: "#fff", color: "#1f2937" },
            formatter: (cell) => cell ? cell : "-"
        },
        {
            dataField: "branch_id",
            text: "Branch",
            sort: true,
            formatter: (cell) => this.resolveBranchName(cell),
        },
        {
            dataField: "class_id",
            text: "Class",
            sort: true,
            formatter: (cell) => this.resolveClassName(cell),
        },
        {
            dataField: "section_id",
            text: "Section",
            sort: true,
            formatter: (cell) => this.resolveSectionName(cell),
        },
        {
            dataField: "working_days",
            text: "Biometric Days",
            formatter: (cell) => this.badgeFormatter(cell, "#4169e1"),
        },
        {
            dataField: "present",
            text: "Punched Days",
            formatter: (cell) => this.badgeFormatter(cell, "#37c978"),
        },
        {
            dataField: "absent",
            text: "Absent (No Punch)",
            formatter: (cell) => this.badgeFormatter(cell, "#e11d48"),
        },
        {
            dataField: "attendance_percentage",
            text: "Biometric %",
            formatter: (cell) => this.attendanceFormatter(cell),
        },
    ];

    selected11Columns = [
        {
            dataField: "sno",
            text: "S.No",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "admission_no",
            text: "Biometric User ID / Adm No",
            sort: true,
        },
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
        },
        {
            dataField: "roll_no",
            text: "Roll No",
            sort: true,
        },
        {
            dataField: "punch_type",
            text: "Punch Type",
            sort: true,
            formatter: (cell) => {
                const type = String(cell).toUpperCase();
                return (
                    <span style={{
                        display: "inline-block", minWidth: 46, textAlign: "center",
                        padding: "2px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                        color: "#fff", background: type === "IN" ? "#37c978" : type === "OUT" ? "#e11d48" : "#94a3b8"
                    }}>
                        {cell || "—"}
                    </span>
                );
            }
        },
        {
            dataField: "punch_time",
            text: "Punch Time",
            sort: true,
            formatter: (cell) => cell ? fmtDMYTime(cell) : "—"
        },
        {
            dataField: "device_id",
            text: "Device ID",
            sort: true,
        },
        {
            dataField: "sync_at",
            text: "Sync Time",
            sort: true,
            formatter: (cell) => cell ? fmtDMYTime(cell) : "—"
        }
    ];

    selected12Columns = [
        {
            dataField: "sno",
            text: "S.No",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "device_id",
            text: "Device ID / Machine ID",
            sort: true,
            style: { fontWeight: "700" }
        },
        {
            dataField: "total_punches",
            text: "Total Punches Logged",
            sort: true,
            formatter: (cell) => (
                <span style={{ background: "#eef2ff", color: "#4f46e5", padding: "4px 10px", borderRadius: "12px", fontWeight: "700" }}>
                    {cell} punches
                </span>
            )
        },
        {
            dataField: "last_punch_time",
            text: "Last Punch Log Time",
            sort: true,
            formatter: (cell) => cell ? fmtDMYTime(cell) : "—"
        },
        {
            dataField: "last_sync_at",
            text: "Last Sync Time",
            sort: true,
            formatter: (cell) => cell ? fmtDMYTime(cell) : "—"
        },
        {
            dataField: "status",
            text: "Sync Network Status",
            formatter: (cell, row) => {
                const isOnline = row.last_sync_at && (new Date() - new Date(row.last_sync_at)) < (12 * 60 * 60 * 1000);
                return (
                    <span style={{
                        display: "inline-block", padding: "3px 10px", borderRadius: "12px", fontSize: "11px", fontWeight: "700",
                        background: isOnline ? "#dcfce7" : "#fee2e2", color: isOnline ? "#166534" : "#991b1b"
                    }}>
                        <i className={`fas fa-circle mr-1`} style={{ fontSize: "8px", color: isOnline ? "#22c55e" : "#ef4444" }} />
                        {isOnline ? "Online (Healthy)" : "Sync Delay (Check Connection)"}
                    </span>
                );
            }
        }
    ];

    badgeFormatter = (value, color) => {
        return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                <span style={{
                    // display: "inline-flex",
                    // alignItems: "center",
                    // justifyContent: "center",
                    // padding: "2px 14px",
                    // borderRadius: 20,
                    // background: color + "18",
                    color: color,
                    // fontWeight: 700,
                    // fontSize: 13,
                    // border: `1.5px solid ${color}55`,
                    // letterSpacing: 0.3,
                    // minWidth: 38,
                    // lineHeight: "20px",
                }}>
                    {value ?? "-"}
                </span>
            </div>
        );
    };

    attendanceFormatter = (cell) => {
        const val = parseFloat(cell);
        const color = isNaN(val) ? "#94a3b8" : val >= 85 ? "#10b981" : val >= 75 ? "#f59e0b" : "#ef4444";
        return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                <span style={{
                    // display: "inline-flex",
                    // alignItems: "center",
                    // justifyContent: "center",
                    // padding: "2px 14px",
                    // borderRadius: 20,
                    // background: color + "18",
                    color: color,
                    // fontWeight: 700,
                    // fontSize: 13,
                    // border: `1.5px solid ${color}55`,
                    // letterSpacing: 0.3,
                    // minWidth: 52,
                    // lineHeight: "20px",
                }}>
                    {cell != null ? cell : "-"}
                </span>
            </div>
        );
    };


    renderSummaryStats() {
        const { attendanceReport, selected } = this.state;
        if (!attendanceReport.length || selected === 11 || selected === 12) return null;

        const GRADIENTS = {
            "#6366f1": "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
            "#10b981": "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            "#ef4444": "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            "#f59e0b": "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
            "#4169e1": "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
        };

        let stats = [];
        if (selected === 1) {
            // Distinct attendance dates — not the section×date row count.
            const workingDays = new Set(attendanceReport.map(r => r.att_date)).size;
            const totalPresent = attendanceReport.reduce((s, r) => s + (parseInt(r.present) || 0), 0);
            const totalAbsent = attendanceReport.reduce((s, r) => s + (parseInt(r.absent) || 0), 0);
            const totalRatio = totalPresent + totalAbsent || 1;
            const avgPct = ((totalPresent / totalRatio) * 100).toFixed(1);
            stats = [
                { label: "Working Days", value: workingDays, color: "#6366f1", icon: <i className="far fa-calendar-alt"></i> },
                { label: "Total Present", value: ((totalPresent / totalRatio) * 100).toFixed(1) + "%", color: "#10b981", icon: <i className="fas fa-check-circle"></i> },
                { label: "Total Absent", value: ((totalAbsent / totalRatio) * 100).toFixed(1) + "%", color: "#ef4444", icon: <i className="fas fa-times-circle"></i> },
                // { label: "Avg Attendance", value: avgPct + "%", color: "#f59e0b", icon: <i className="fas fa-chart-line"></i> },
            ];
        } else if (selected === 2) {
            const n = attendanceReport.length;
            // total_working_days is PER STUDENT and they legitimately differ (a student who
            // joined mid-month has fewer). Reading row [0] made this KPI depend on sort
            // order — it showed the first student's figure, not the month's. The max is the
            // number of days attendance was taken for anyone, i.e. the month's working days;
            // each student's own count stays in their row.
            const workingDays = attendanceReport.reduce(
                (mx, r) => Math.max(mx, parseInt(r.total_working_days) || 0),
                0,
            );
            const totalPresent = attendanceReport.reduce((s, r) => s + (parseInt(r.total_present) || 0), 0);
            const totalAbsent = attendanceReport.reduce((s, r) => s + (parseInt(r.total_absent) || 0), 0);
            const totalRatio = totalPresent + totalAbsent || 1;
            stats = [
                { label: "Total Students", value: n, color: "#6366f1", icon: <i className="fas fa-user-graduate"></i> },
                { label: "Working Days", value: workingDays, color: "#4169e1", icon: <i className="far fa-calendar-alt"></i> },
                { label: "Total Present", value: ((totalPresent / totalRatio) * 100).toFixed(1) + "%", color: "#10b981", icon: <i className="fas fa-check-circle"></i> },
                { label: "Total Absent", value: ((totalAbsent / totalRatio) * 100).toFixed(1) + "%", color: "#ef4444", icon: <i className="fas fa-times-circle"></i> },
            ];
        } else if (selected === 3) {
            const n = attendanceReport.length;
            const totalPresent = attendanceReport.reduce((s, r) => s + (parseInt(r.present) || 0), 0);
            const totalAbsent = attendanceReport.reduce((s, r) => s + (parseInt(r.absent) || 0), 0);
            const totalRatio = totalPresent + totalAbsent || 1;
            const avgPct = ((totalPresent / totalRatio) * 100).toFixed(1);
            stats = [
                { label: "Total Students", value: n, color: "#6366f1", icon: <i className="fas fa-user-graduate"></i> },
                { label: "Total Present", value: ((totalPresent / totalRatio) * 100).toFixed(1) + "%", color: "#10b981", icon: <i className="fas fa-check-circle"></i> },
                { label: "Total Absent", value: ((totalAbsent / totalRatio) * 100).toFixed(1) + "%", color: "#ef4444", icon: <i className="fas fa-times-circle"></i> },
                // { label: "Avg Attendance", value: avgPct + "%", color: "#f59e0b", icon: <i className="fas fa-chart-line"></i> },
            ];
        } else if (selected === 4) {
            const totalSections = attendanceReport.length;
            let totalPresent = 0, totalAbsent = 0;
            const allDates = new Set();
            let totalStudents = 0;
            attendanceReport.forEach(row => {
                totalStudents += parseInt(row.total_students) || 0;
                (row.dateWiseData || []).forEach(d => {
                    // Only days that actually have attendance taken are "working days".
                    if (d.present === null || d.present === undefined) return;
                    totalPresent += parseInt(d.present) || 0;
                    totalAbsent += parseInt(d.absent) || 0;
                    allDates.add(d.date);
                });
            });
            const totalRatio = totalPresent + totalAbsent || 1;
            stats = [
                { label: "Total Sections", value: totalSections, color: "#6366f1", icon: <i className="fas fa-layer-group"></i> },
                { label: "Students Count", value: totalStudents, color: "#f59e0b", icon: <i className="fas fa-user-graduate"></i> },
                { label: "Working Days", value: allDates.size, color: "#4169e1", icon: <i className="far fa-calendar-alt"></i> },
                { label: "Total Present", value: ((totalPresent / totalRatio) * 100).toFixed(1) + "%", color: "#10b981", icon: <i className="fas fa-check-circle"></i> },
                { label: "Total Absent", value: ((totalAbsent / totalRatio) * 100).toFixed(1) + "%", color: "#ef4444", icon: <i className="fas fa-times-circle"></i> },
            ];
        } else if (selected === 5) {
            const n = attendanceReport.length;
            let totalPresent = 0, totalAbsent = 0;
            const allDates = new Set();
            attendanceReport.forEach(row => {
                (row.dateWiseData || []).forEach(d => {
                    allDates.add(d.date);
                    (d.periods || []).forEach(p => {
                        if (p.status === "P") totalPresent++;
                        if (p.status === "A") totalAbsent++;
                    });
                });
            });
            const totalRatio = totalPresent + totalAbsent || 1;
            stats = [
                { label: "Total Students", value: n, color: "#6366f1", icon: <i className="fas fa-user-graduate"></i> },
                { label: "Working Days", value: allDates.size, color: "#4169e1", icon: <i className="far fa-calendar-alt"></i> },
                { label: "Total Present", value: ((totalPresent / totalRatio) * 100).toFixed(1) + "%", color: "#10b981", icon: <i className="fas fa-check-circle"></i> },
                { label: "Total Absent", value: ((totalAbsent / totalRatio) * 100).toFixed(1) + "%", color: "#ef4444", icon: <i className="fas fa-times-circle"></i> },
            ];
        }

        return (
            <Row className="mb-3">
                {stats.map((stat, i) => {
                    return (
                        <Col
                            key={i}
                            xs={12}
                            sm={6}
                            md={[1, 3, 4].includes(selected) ? 4 : 3}
                            lg={selected === 4 ? true : undefined}
                            className="mb-3"
                        >
                            <div style={styles.statCard(stat.color)}>
                                <div style={{
                                    width: 52,
                                    height: 52,
                                    borderRadius: 12,
                                    background: `${stat.color}20`,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 22,
                                    color: stat.color,
                                    flexShrink: 0,
                                }}>
                                    {stat.icon}
                                </div>
                                <div style={{ textAlign: "left" }}>
                                    <div style={{
                                        fontSize: 10,
                                        fontWeight: 700,
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                        color: "#6b7280",
                                        lineHeight: 1.2,
                                    }}>
                                        {stat.label}
                                    </div>
                                    <div style={{
                                        fontSize: 22,
                                        fontWeight: 800,
                                        color: "#1f2937",
                                        marginTop: 3,
                                        lineHeight: 1.1,
                                    }}>
                                        {stat.value}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        );
    }

    renderGraph() {
        const { attendanceReport, selected } = this.state;
        if (!attendanceReport.length) return null;

        const COLORS = { present: "#10b981", absent: "#ef4444", total: "#6366f1", pct: "#f59e0b" };
        const PIE_COLORS = ["#10b981", "#f59e0b", "#ef4444"];

        if (selected === 1) {
            const { trend1BarsVisible } = this.state;
            const data = attendanceReport.map(r => ({
                // Chart X-axis label. Plot order comes from the backend's ordering, so
                // formatting here is display-only and doesn't affect sorting.
                date: fmtDMY(r.att_date),
                Total: parseInt(r.total_students) || 0,
                Present: parseInt(r.present) || 0,
                Absent: parseInt(r.absent) || 0,
                "Attendance %": parseFloat(r.percentage) || 0,
            }));
            const trend1Defs = [
                { key: "Total", color: COLORS.total },
                { key: "Present", color: COLORS.present },
                { key: "Absent", color: COLORS.absent },
                { key: "Attendance %", color: COLORS.pct },
            ];
            const trend1AllSelected = trend1Defs.every(b => trend1BarsVisible[b.key]);
            const toggleTrend1 = (key) => this.setState(prev => ({ trend1BarsVisible: { ...prev.trend1BarsVisible, [key]: !prev.trend1BarsVisible[key] } }));
            const setAllTrend1 = (val) => this.setState({ trend1BarsVisible: { Total: val, Present: val, Absent: val, "Attendance %": val } });
            return (
                <div style={styles.graphCard}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
                        <div style={styles.graphTitle}><span>📈</span> Class Attendance Trend</div>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                            {trend1Defs.map(b => (
                                <button key={b.key} onClick={() => toggleTrend1(b.key)} style={{ display: "flex", alignItems: "center", gap: 5, padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: `1.5px solid ${b.color}`, background: trend1BarsVisible[b.key] ? b.color : "#fff", color: trend1BarsVisible[b.key] ? "#fff" : b.color, transition: "all 0.15s" }}>
                                    <span style={{ width: 8, height: 8, borderRadius: "50%", background: trend1BarsVisible[b.key] ? "#fff" : b.color, display: "inline-block" }} />
                                    {b.key}
                                </button>
                            ))}
                            <button onClick={() => setAllTrend1(!trend1AllSelected)} style={{ padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "1.5px solid #6b7280", background: trend1AllSelected ? "#6b7280" : "#fff", color: trend1AllSelected ? "#fff" : "#6b7280", transition: "all 0.15s" }}>
                                {trend1AllSelected ? "Unselect All" : "Select All"}
                            </button>
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <ComposedChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
                            <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#6b7280" }} />
                            <YAxis yAxisId="left" tick={{ fontSize: 11, fill: "#6b7280" }} />
                            <YAxis yAxisId="right" orientation="right" domain={[0, 100]} unit="%" tick={{ fontSize: 11, fill: "#6b7280" }} />
                            <Tooltip contentStyle={{ borderRadius: 10, border: "1px solid #e5e7eb", fontSize: 13 }} />
                            <Legend wrapperStyle={{ fontSize: 13 }} />
                            {trend1BarsVisible.Total && <Bar yAxisId="left" dataKey="Total" fill={COLORS.total} radius={[5, 5, 0, 0]} />}
                            {trend1BarsVisible.Present && <Bar yAxisId="left" dataKey="Present" fill={COLORS.present} radius={[5, 5, 0, 0]} />}
                            {trend1BarsVisible.Absent && <Bar yAxisId="left" dataKey="Absent" fill={COLORS.absent} radius={[5, 5, 0, 0]} />}
                            {trend1BarsVisible["Attendance %"] && <Line yAxisId="right" type="monotone" dataKey="Attendance %" stroke={COLORS.pct} strokeWidth={2.5} dot={false} strokeDasharray="5 3" />}
                        </ComposedChart>
                    </ResponsiveContainer>
                </div>
            );
        }

        if (selected === 2) {
            const { monthlyBarsVisible } = this.state;
            const barData = attendanceReport.map(r => ({
                name: r.student_name || r.roll_no || "",
                "Working Days": parseInt(r.total_working_days) || 0,
                Present: parseInt(r.total_present) || 0,
                Absent: parseInt(r.total_absent) || 0,
            }));
            const excellent = attendanceReport.filter(r => parseFloat(r.percentage) >= 85).length;
            const good = attendanceReport.filter(r => parseFloat(r.percentage) >= 75 && parseFloat(r.percentage) < 85).length;
            const poor = attendanceReport.filter(r => parseFloat(r.percentage) < 75).length;
            const pieData = [
                { name: "≥85% Excellent", value: excellent },
                { name: "75–84% Good", value: good },
                { name: "<75% At Risk", value: poor },
            ].filter(d => d.value > 0);
            const barChartWidth = Math.max(barData.length * 80, 600);
            const barDefs = [
                { key: "Working Days", color: COLORS.total },
                { key: "Present", color: COLORS.present },
                { key: "Absent", color: COLORS.absent },
            ];
            const allSelected = barDefs.every(b => monthlyBarsVisible[b.key]);
            const toggleBar = (key) => this.setState(prev => ({
                monthlyBarsVisible: { ...prev.monthlyBarsVisible, [key]: !prev.monthlyBarsVisible[key] }
            }));
            const setAll = (val) => this.setState({
                monthlyBarsVisible: { "Working Days": val, Present: val, Absent: val }
            });

            return (
                <Row className="mb-2">
                    <Col md={8}>
                        <div style={styles.graphCard}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
                                <div style={styles.graphTitle}><span>📅</span> Monthly Student Attendance <span style={{ fontSize: 11, color: "#9ca3af", fontWeight: 400 }}>({attendanceReport.length} students)</span></div>
                                <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                    {barDefs.map(b => (
                                        <button key={b.key} onClick={() => toggleBar(b.key)} style={{ display: "flex", alignItems: "center", gap: 5, padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: `1.5px solid ${b.color}`, background: monthlyBarsVisible[b.key] ? b.color : "#fff", color: monthlyBarsVisible[b.key] ? "#fff" : b.color, transition: "all 0.15s" }}>
                                            <span style={{ width: 8, height: 8, borderRadius: "50%", background: monthlyBarsVisible[b.key] ? "#fff" : b.color, display: "inline-block" }} />
                                            {b.key}
                                        </button>
                                    ))}
                                    <button onClick={() => setAll(!allSelected)} style={{ padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "1.5px solid #6b7280", background: allSelected ? "#6b7280" : "#fff", color: allSelected ? "#fff" : "#6b7280", transition: "all 0.15s" }}>
                                        {allSelected ? "Unselect All" : "Select All"}
                                    </button>
                                </div>
                            </div>
                            <div style={{ overflowX: "auto", width: "100%" }}>
                                <BarChart data={barData} width={barChartWidth} height={320} margin={{ top: 5, right: 10, left: 0, bottom: 80 }}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
                                    <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#6b7280" }} angle={-40} textAnchor="end" interval={0} />
                                    <YAxis tick={{ fontSize: 11, fill: "#6b7280" }} />
                                    <Tooltip contentStyle={{ borderRadius: 10, border: "1px solid #e5e7eb", fontSize: 13 }} />
                                    {monthlyBarsVisible["Working Days"] && <Bar dataKey="Working Days" fill={COLORS.total} radius={[5, 5, 0, 0]} />}
                                    {monthlyBarsVisible.Present && <Bar dataKey="Present" fill={COLORS.present} radius={[5, 5, 0, 0]} />}
                                    {monthlyBarsVisible.Absent && <Bar dataKey="Absent" fill={COLORS.absent} radius={[5, 5, 0, 0]} />}
                                </BarChart>
                            </div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{ ...styles.graphCard, height: "calc(100% - 20px)" }}>
                            <div style={styles.graphTitle}><span>🥧</span> Attendance Distribution</div>
                            <ResponsiveContainer width="100%" height={260}>
                                <PieChart>
                                    <Pie data={pieData} cx="50%" cy="45%" outerRadius={90} innerRadius={50} dataKey="value" label={({ percent }) => `${(percent * 100).toFixed(0)}%`} labelLine={false}>
                                        {pieData.map((_, i) => <Cell key={i} fill={PIE_COLORS[i]} />)}
                                    </Pie>
                                    <Tooltip formatter={(v, n) => [`${v} students`, n]} contentStyle={{ borderRadius: 10, fontSize: 13 }} />
                                    <Legend wrapperStyle={{ fontSize: 12 }} />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </Col>
                </Row>
            );
        }

        if (selected === 3) {
            const { overview3BarsVisible } = this.state;
            const barData = attendanceReport.map(r => ({
                name: r.student_name || r.roll_no || "",
                "Working Days": parseInt(r.working_days) || 0,
                Present: parseInt(r.present) || 0,
                Absent: parseInt(r.absent) || 0,
            }));
            const excellent = attendanceReport.filter(r => parseFloat(r.attendance_percentage) >= 85).length;
            const good = attendanceReport.filter(r => parseFloat(r.attendance_percentage) >= 75 && parseFloat(r.attendance_percentage) < 85).length;
            const poor = attendanceReport.filter(r => parseFloat(r.attendance_percentage) < 75).length;
            const pieData = [
                { name: "≥85% Excellent", value: excellent },
                { name: "75–84% Good", value: good },
                { name: "<75% At Risk", value: poor },
            ].filter(d => d.value > 0);
            const overview3Defs = [
                { key: "Working Days", color: COLORS.total },
                { key: "Present", color: COLORS.present },
                { key: "Absent", color: COLORS.absent },
            ];
            const overview3AllSelected = overview3Defs.every(b => overview3BarsVisible[b.key]);
            const toggleOverview3 = (key) => this.setState(prev => ({ overview3BarsVisible: { ...prev.overview3BarsVisible, [key]: !prev.overview3BarsVisible[key] } }));
            const setAllOverview3 = (val) => this.setState({ overview3BarsVisible: { "Working Days": val, Present: val, Absent: val } });
            const overview3ChartWidth = Math.max(barData.length * 80, 600);

            return (
                <Row className="mb-2">
                    <Col md={8}>
                        <div style={styles.graphCard}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
                                <div style={styles.graphTitle}><span>🎓</span> Student Attendance Overview <span style={{ fontSize: 11, color: "#9ca3af", fontWeight: 400 }}>({attendanceReport.length} students)</span></div>
                                <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                    {overview3Defs.map(b => (
                                        <button key={b.key} onClick={() => toggleOverview3(b.key)} style={{ display: "flex", alignItems: "center", gap: 5, padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: `1.5px solid ${b.color}`, background: overview3BarsVisible[b.key] ? b.color : "#fff", color: overview3BarsVisible[b.key] ? "#fff" : b.color, transition: "all 0.15s" }}>
                                            <span style={{ width: 8, height: 8, borderRadius: "50%", background: overview3BarsVisible[b.key] ? "#fff" : b.color, display: "inline-block" }} />
                                            {b.key}
                                        </button>
                                    ))}
                                    <button onClick={() => setAllOverview3(!overview3AllSelected)} style={{ padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "1.5px solid #6b7280", background: overview3AllSelected ? "#6b7280" : "#fff", color: overview3AllSelected ? "#fff" : "#6b7280", transition: "all 0.15s" }}>
                                        {overview3AllSelected ? "Unselect All" : "Select All"}
                                    </button>
                                </div>
                            </div>
                            <div style={{ overflowX: "auto", width: "100%" }}>
                                <BarChart data={barData} width={overview3ChartWidth} height={320} margin={{ top: 5, right: 10, left: 0, bottom: 80 }}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
                                    <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#6b7280" }} angle={-40} textAnchor="end" interval={0} />
                                    <YAxis tick={{ fontSize: 11, fill: "#6b7280" }} />
                                    <Tooltip contentStyle={{ borderRadius: 10, border: "1px solid #e5e7eb", fontSize: 13 }} />
                                    <Legend wrapperStyle={{ fontSize: 13 }} />
                                    {overview3BarsVisible["Working Days"] && <Bar dataKey="Working Days" fill={COLORS.total} radius={[5, 5, 0, 0]} />}
                                    {overview3BarsVisible.Present && <Bar dataKey="Present" fill={COLORS.present} radius={[5, 5, 0, 0]} />}
                                    {overview3BarsVisible.Absent && <Bar dataKey="Absent" fill={COLORS.absent} radius={[5, 5, 0, 0]} />}
                                </BarChart>
                            </div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{ ...styles.graphCard, height: "calc(100% - 20px)" }}>
                            <div style={styles.graphTitle}><span>🥧</span> Attendance Distribution</div>
                            <ResponsiveContainer width="100%" height={260}>
                                <PieChart>
                                    <Pie data={pieData} cx="50%" cy="45%" outerRadius={90} innerRadius={50} dataKey="value" label={({ percent }) => `${(percent * 100).toFixed(0)}%`} labelLine={false}>
                                        {pieData.map((_, i) => <Cell key={i} fill={PIE_COLORS[i]} />)}
                                    </Pie>
                                    <Tooltip formatter={(v, n) => [`${v} students`, n]} contentStyle={{ borderRadius: 10, fontSize: 13 }} />
                                    <Legend wrapperStyle={{ fontSize: 12 }} />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </Col>
                </Row>
            );
        }

        if (selected === 4) {
            const { consolidated4BarsVisible } = this.state;
            const barData = this.state.attendanceReport.map(row => {
                const totals = (row.dateWiseData || []).reduce((acc, d) => {
                    acc.Present += parseInt(d.present) || 0;
                    acc.Absent += parseInt(d.absent) || 0;
                    acc.Total += parseInt(d.total) || 0;
                    return acc;
                }, { Present: 0, Absent: 0, Total: 0 });
                const classLabel = row.class_name || this.resolveClassName(row.class_id);
                const sectionLabel = this.resolveSectionName(row.section_id);
                const branchLabel = this.resolveBranchName(row.branch_id);
                return { name: `${classLabel} — ${sectionLabel} (${branchLabel})`, ...totals };
            });
            const consolidated4Defs = [
                { key: "Total", color: COLORS.total },
                { key: "Present", color: COLORS.present },
                { key: "Absent", color: COLORS.absent },
            ];
            const consolidated4AllSelected = consolidated4Defs.every(b => consolidated4BarsVisible[b.key]);
            const toggleConsolidated4 = (key) => this.setState(prev => ({ consolidated4BarsVisible: { ...prev.consolidated4BarsVisible, [key]: !prev.consolidated4BarsVisible[key] } }));
            const setAllConsolidated4 = (val) => this.setState({ consolidated4BarsVisible: { Present: val, Absent: val, Total: val } });
            return (
                <div style={styles.graphCard}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
                        <div style={styles.graphTitle}><span>📊</span> Consolidated Class-Wise Attendance</div>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                            {consolidated4Defs.map(b => (
                                <button key={b.key} onClick={() => toggleConsolidated4(b.key)} style={{ display: "flex", alignItems: "center", gap: 5, padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: `1.5px solid ${b.color}`, background: consolidated4BarsVisible[b.key] ? b.color : "#fff", color: consolidated4BarsVisible[b.key] ? "#fff" : b.color, transition: "all 0.15s" }}>
                                    <span style={{ width: 8, height: 8, borderRadius: "50%", background: consolidated4BarsVisible[b.key] ? "#fff" : b.color, display: "inline-block" }} />
                                    {b.key}
                                </button>
                            ))}
                            <button onClick={() => setAllConsolidated4(!consolidated4AllSelected)} style={{ padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "1.5px solid #6b7280", background: consolidated4AllSelected ? "#6b7280" : "#fff", color: consolidated4AllSelected ? "#fff" : "#6b7280", transition: "all 0.15s" }}>
                                {consolidated4AllSelected ? "Unselect All" : "Select All"}
                            </button>
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={barData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
                            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#374151" }} />
                            <YAxis tick={{ fontSize: 11, fill: "#6b7280" }} />
                            <Tooltip contentStyle={{ borderRadius: 10, border: "1px solid #e5e7eb", fontSize: 13 }} />
                            <Legend wrapperStyle={{ fontSize: 13 }} />
                            {consolidated4BarsVisible.Present && <Bar dataKey="Present" fill={COLORS.present} radius={[5, 5, 0, 0]} />}
                            {consolidated4BarsVisible.Absent && <Bar dataKey="Absent" fill={COLORS.absent} radius={[5, 5, 0, 0]} />}
                            {consolidated4BarsVisible.Total && <Bar dataKey="Total" fill={COLORS.total} radius={[5, 5, 0, 0]} />}
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            );
        }

        return null;
    }

    formatPeriodWiseDateLabel = (dateStr, dayOfWeek) => {
        const m = moment(dateStr, ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601], true);
        const dayPart = m.isValid() ? m.format("DD") : String(dateStr).slice(-2);
        const dow = dayOfWeek ? String(dayOfWeek).slice(0, 3) : (m.isValid() ? m.format("ddd") : "");
        return dow ? `${dayPart} ${dow}` : dayPart;
    };

    getPeriodWiseMonthTitle = (monthId) => {
        const option = monthOptions.find((m) => m.value === monthId);
        if (option) {
            const parts = option.label.split(" - ");
            return `${parts[0]} ${parts[1] || ""}`.trim();
        }
        const parsed = moment(monthId, "YYYY-MM", true);
        return parsed.isValid() ? parsed.format("MMMM YYYY") : monthId;
    };

    getPeriodWiseFilteredRows = () => {
        const { attendanceReport, periodWiseSearch } = this.state;
        const q = (periodWiseSearch || "").trim().toLowerCase();
        if (!q) return attendanceReport;
        return attendanceReport.filter((row) => {
            const roll = String(row.roll_no ?? "").toLowerCase();
            const name = String(row.student_name ?? "").toLowerCase();
            const sr = String(row.sr_no ?? "").toLowerCase();
            return roll.includes(q) || name.includes(q) || sr.includes(q);
        });
    };

    handlePeriodWiseSearchChange = (e) => {
        this.setState({ periodWiseSearch: e.target.value, periodWisePage: 1 });
    };

    handlePeriodWisePageSizeChange = (e) => {
        const periodWisePageSize = parseInt(e.target.value, 10) || 10;
        this.setState({ periodWisePageSize, periodWisePage: 1 });
    };

    handlePeriodWisePageChange = (page) => {
        const filtered = this.getPeriodWiseFilteredRows();
        const totalPages = Math.max(1, Math.ceil(filtered.length / this.state.periodWisePageSize));
        const nextPage = Math.min(Math.max(1, page), totalPages);
        this.setState({ periodWisePage: nextPage });
    };

    getConsolidatedFilteredRows = () => {
        const { attendanceReport, consolidated4Search } = this.state;
        const q = (consolidated4Search || "").trim().toLowerCase();
        if (!q) return attendanceReport;
        return attendanceReport.filter((row, idx) => {
            const sr = String(row.sr_no ?? idx + 1).toLowerCase();
            const branch = String(this.resolveBranchName(row.branch_id) ?? "").toLowerCase();
            const cls = String((row.class_name || this.resolveClassName(row.class_id)) ?? "").toLowerCase();
            const section = String(this.resolveSectionName(row.section_id) ?? "").toLowerCase();
            return sr.includes(q) || branch.includes(q) || cls.includes(q) || section.includes(q);
        });
    };

    handleConsolidatedSearchChange = (e) => {
        this.setState({ consolidated4Search: e.target.value, consolidated4Page: 1 });
    };

    handleConsolidatedPageSizeChange = (e) => {
        const consolidated4PageSize = parseInt(e.target.value, 10) || 10;
        this.setState({ consolidated4PageSize, consolidated4Page: 1 });
    };

    handleConsolidatedPageChange = (page) => {
        const filtered = this.getConsolidatedFilteredRows();
        const totalPages = Math.max(1, Math.ceil(filtered.length / this.state.consolidated4PageSize));
        const nextPage = Math.min(Math.max(1, page), totalPages);
        this.setState({ consolidated4Page: nextPage });
    };

    renderReportSearchAndPageSize = ({ searchValue, onSearchChange, searchPlaceholder }) => (
        <Row className="g-2 align-items-end mb-3">
            <Col xs={12} md={5}>
                <div style={styles.label}>Search</div>
                <InputGroup>
                    <InputGroup.Prepend>
                        <InputGroup.Text style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRight: 0 }}>
                            <i class="fa fa-search"></i>
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                        style={{ ...styles.input, borderLeft: 0 }}
                        placeholder={searchPlaceholder}
                        value={searchValue}
                        onChange={onSearchChange}
                    />
                </InputGroup>
            </Col>
        </Row>
    );

    renderReportPagination = (totalFiltered, currentPage, pageSize, onPageChange, onPageSizeChange, itemLabel = "row") => {
        const totalPages = Math.max(1, Math.ceil(totalFiltered / pageSize) || 1);
        const safePage = Math.min(currentPage, totalPages);
        const from = totalFiltered === 0 ? 0 : (safePage - 1) * pageSize + 1;
        const to = Math.min(safePage * pageSize, totalFiltered);

        const pageSizeSelectStyle = {
            padding: "6px 12px",
            borderRadius: 8,
            border: "1.5px solid #c084fc",
            background: "#f3e8ff",
            color: "#6b21a8",
            outline: "none",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 13,
        };

        const pageBtnStyle = (active) => ({
            minWidth: 36,
            height: 36,
            borderRadius: 8,
            border: active ? "none" : "1px solid #e5e7eb",
            background: active ? "#dee2e6" : "#f9fafb",
            color: active ? "#1f2937" : "#374151",
            borderColor: active ? "#dee2e6" : "#e5e7eb",
            fontWeight: 600,
            fontSize: 13,
            cursor: "pointer",
        });

        const navBtnStyle = (disabled) => ({
            padding: "6px 14px",
            borderRadius: 8,
            border: "1px solid #e5e7eb",
            background: disabled ? "#f3f4f6" : "#fff",
            color: disabled ? "#9ca3af" : "#4f46e5",
            fontWeight: 600,
            fontSize: 13,
            cursor: disabled ? "not-allowed" : "pointer",
        });

        const maxVisible = 7;
        let startPage = Math.max(1, safePage - Math.floor(maxVisible / 2));
        let endPage = Math.min(totalPages, startPage + maxVisible - 1);
        startPage = Math.max(1, endPage - maxVisible + 1);
        const pageNumbers = [];
        for (let p = startPage; p <= endPage; p++) pageNumbers.push(p);

        return (
            <Row className="mt-3 align-items-center">
                <Col xs={12} md={5} className="mb-2 mb-md-0">
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <select
                            style={pageSizeSelectStyle}
                            value={pageSize}
                            onChange={(e) => onPageSizeChange(e.target.value)}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <span style={{ fontSize: 13, color: "#4b5563", fontWeight: 500 }}>
                            Showing {from} to {to} of {totalFiltered} Results
                        </span>
                    </div>
                </Col>
                <Col xs={12} md={7}>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "flex-end", alignItems: "center" }}>
                        <button
                            type="button"
                            style={navBtnStyle(safePage <= 1)}
                            disabled={safePage <= 1}
                            onClick={() => onPageChange(safePage - 1)}
                        >
                            Previous
                        </button>
                        {pageNumbers.map((p) => (
                            <button
                                key={p}
                                type="button"
                                style={pageBtnStyle(p === safePage)}
                                onClick={() => onPageChange(p)}
                            >
                                {p}
                            </button>
                        ))}
                        <button
                            type="button"
                            style={navBtnStyle(safePage >= totalPages)}
                            disabled={safePage >= totalPages}
                            onClick={() => onPageChange(safePage + 1)}
                        >
                            Next
                        </button>
                    </div>
                </Col>
            </Row>
        );
    };

    renderPeriodWisePagination = (totalFiltered) => {
        const { periodWisePage, periodWisePageSize } = this.state;
        return this.renderReportPagination(
            totalFiltered,
            periodWisePage,
            periodWisePageSize,
            this.handlePeriodWisePageChange,
            (val) => this.handlePeriodWisePageSizeChange({ target: { value: val } }),
            "student"
        );
    };

    mergePeriodLabels = (existingLabels, periods, periodCount) => {
        const labels = [...(existingLabels || [])];
        while (labels.length < periodCount) labels.push("");
        (periods || []).forEach((p) => {
            const idx = (+p.period_no) - 1;
            if (idx < 0 || idx >= periodCount) return;
            const name = (p.subtype_name || "").trim();
            if (name) labels[idx] = name;
            else if (!labels[idx]) labels[idx] = `P${p.period_no}`;
        });
        return labels.map((label, i) => label || `P${i + 1}`);
    };

    buildPeriodWiseDateColumns = (attendanceReport) => {
        const dateMap = new Map();
        (attendanceReport || []).forEach((row) => {
            (row.dateWiseData || []).forEach((d) => {
                const periodCount = (d.periods || []).length;
                if (!dateMap.has(d.date)) {
                    dateMap.set(d.date, {
                        date: d.date,
                        day_of_week: d.day_of_week,
                        is_holiday: !!d.is_holiday,
                        periodCount,
                        periodLabels: this.mergePeriodLabels([], d.periods, periodCount),
                        dateLabel: this.formatPeriodWiseDateLabel(d.date, d.day_of_week),
                    });
                } else {
                    const existing = dateMap.get(d.date);
                    existing.periodCount = Math.max(existing.periodCount, periodCount);
                    existing.periodLabels = this.mergePeriodLabels(
                        existing.periodLabels,
                        d.periods,
                        existing.periodCount
                    );
                    if (d.is_holiday) existing.is_holiday = true;
                }
            });
        });
        return [...dateMap.values()].sort((a, b) => String(a.date).localeCompare(String(b.date)));
    };

    getPeriodStatusCellStyle = (status, isHoliday) => {
        if (isHoliday || status === "H") return PERIOD_STATUS_STYLES.H;
        return PERIOD_STATUS_STYLES[status] || {
            // background: "#f3f4f6",
            color: "#6b7280"
        };
    };

    renderPeriodStatusCell = (status, isHoliday) => {
        const display = isHoliday ? "H" : (status || "-");
        const cellStyle = this.getPeriodStatusCellStyle(display, isHoliday);
        return (
            <span style={{
                fontWeight: 700,
                color: cellStyle.color,
            }}>
                {display}
            </span>
        );
    };

    getPeriodWiseFilterSummary = () => {
        const academicYears = this.props.getAcademicYearsQuery?.getAcademicYears || [];
        const yearLabel = academicYears.find((y) => String(y.id) === String(this.state.selectedYear))?.academic_year || "-";
        const branchLabels = this.state.branchSelectedvalue.map((b) => b.label).join(", ") || "-";
        const classLabels = this.state.classSelectedvalue.map((c) => c.label).join(", ") || "-";
        const sectionLabels = this.state.sectionSelectedvalue.map((s) => s.label).join(", ") || "-";
        const monthLabel = monthOptions.find((m) => m.value === this.state.selectedMonthId)?.label || this.state.selectedMonthId;
        return { yearLabel, branchLabels, classLabels, sectionLabels, monthLabel };
    };

    chunkPeriodWiseDateColumns = (dateColumns, maxPeriodColsPerPage = 16) => {
        const chunks = [];
        let current = [];
        let periodColCount = 0;
        (dateColumns || []).forEach((d) => {
            if (current.length && periodColCount + d.periodCount > maxPeriodColsPerPage) {
                chunks.push(current);
                current = [];
                periodColCount = 0;
            }
            current.push(d);
            periodColCount += d.periodCount;
        });
        if (current.length) chunks.push(current);
        return chunks.length ? chunks : [[]];
    };

    buildPeriodWisePrintFilterSummaryHtml = () => {
        const { yearLabel, branchLabels, classLabels, sectionLabels, monthLabel } = this.getPeriodWiseFilterSummary();
        const row = (label, value) =>
            `<div style="flex:1;min-width:140px;font-size:10px;color:#374151;"><strong>${label}:</strong> ${value}</div>`;
        return `<div style="margin-bottom:12px;padding:10px 12px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;">
            <div style="font-weight:700;font-size:12px;color:#4f46e5;margin-bottom:6px;">Period Wise Attendance Report</div>
            <div style="display:flex;flex-wrap:wrap;gap:8px 16px;">
                ${row("Academic Year", yearLabel)}
                ${row("Branch", branchLabels)}
                ${row("Class", classLabels)}
                ${row("Section", sectionLabels)}
                ${row("Month", monthLabel)}
            </div>
        </div>`;
    };

    buildPeriodWisePrintTableHtml = (thStyle, tdStyle, dateColumns) => {
        const { attendanceReport } = this.state;
        const columns = dateColumns || this.buildPeriodWiseDateColumns(attendanceReport);
        const monthTitle = this.getPeriodWiseMonthTitle(this.state.selectedMonthId);
        const totalPeriodCols = columns.reduce((s, d) => s + d.periodCount, 0);
        const subThStyle = 'style="background:#6366f1;color:#fff;font-weight:600;font-size:11px;padding:6px 4px;text-align:center;border:1px solid #ccc;white-space:nowrap;"';

        const monthHeader = totalPeriodCols > 0
            ? `<th ${thStyle} colspan="${totalPeriodCols}">${monthTitle}</th>`
            : "";
        const dateHeaders = columns.map((d) =>
            `<th ${thStyle} colspan="${d.periodCount}">${d.dateLabel}</th>`
        ).join("");
        const periodHeaders = columns.map((d) =>
            Array.from({ length: d.periodCount }, (_, i) => {
                const label = d.periodLabels?.[i] || `P${i + 1}`;
                return `<th ${subThStyle} title="${label}">${label}</th>`;
            }).join("")
        ).join("");

        const bodyRows = attendanceReport.map((row, idx) => {
            const dateMap = {};
            (row.dateWiseData || []).forEach((d) => { dateMap[d.date] = d; });
            const periodCells = columns.map((d) => {
                const dayData = dateMap[d.date];
                return Array.from({ length: d.periodCount }, (_, i) => {
                    const period = (dayData?.periods || []).find((x) => +x.period_no === i + 1);
                    const status = dayData?.is_holiday ? "H" : (period?.status || "-");
                    const st = this.getPeriodStatusCellStyle(status, dayData?.is_holiday);
                    return `<td ${tdStyle} style="color:${st.color};font-weight:700;">${status}</td>`;
                }).join("");
            }).join("");
            return `<tr>
                <td ${tdStyle}>${row.sr_no ?? idx + 1}</td>
                <td ${tdStyle}>${row.roll_no ?? "-"}</td>
                <td ${tdStyle} style="text-align:left;">${row.student_name ?? "-"}</td>
                <!-- <td ${tdStyle}>${row.dob ?? "-"}</td> -->
                <td ${tdStyle} style="text-align:left;">${row.father_name ?? "-"}</td>
                <!-- <td ${tdStyle} style="text-align:left;">${row.mother_name ?? "-"}</td> -->
                <!-- <td ${tdStyle}>${row.father_phone ?? "-"}</td> -->
                <td ${tdStyle}>${this.resolveBranchName(row.branch_id)}</td>
                <td ${tdStyle}>${this.resolveClassName(row.class_id)}</td>  
                <td ${tdStyle}>${this.resolveSectionName(row.section_id)}</td>
                ${periodCells}
            </tr>`;
        }).join("");

        return `<table class="period-wise-print-table">
            <thead>
                <tr>
                    <th ${thStyle} rowspan="3">S.No.</th>
                    <th ${thStyle} rowspan="3">Roll No.</th>
                    <th ${thStyle} rowspan="3">Student Name</th>
                    <!-- <th ${thStyle} rowspan="3">Date of Birth</th> -->
                    <th ${thStyle} rowspan="3">Father Name</th>
                    <!-- <th ${thStyle} rowspan="3">Mother Name</th> -->
                    <!-- <th ${thStyle} rowspan="3">Father Mobile</th> -->
                    <th ${thStyle} rowspan="3">Branch</th>
                    <th ${thStyle} rowspan="3">Class</th>
                    <th ${thStyle} rowspan="3">Section</th>
                    ${monthHeader}
                </tr>
                <tr>${dateHeaders}</tr>
                <tr>${periodHeaders}</tr>
            </thead>
            <tbody>${bodyRows}</tbody>
        </table>`;
    };

    buildConsolidated4PrintHtml = (thStyle, tdStyle) => {
        const { attendanceReport } = this.state;
        const allDates = [];
        const seenDates = new Set();
        attendanceReport.forEach(row => {
            (row.dateWiseData || []).forEach(d => {
                if (!seenDates.has(d.date)) { seenDates.add(d.date); allDates.push(d.date); }
            });
        });
        allDates.sort();

        const MAX_DATES_PER_PAGE = 8;
        const chunks = [];
        for (let i = 0; i < allDates.length; i += MAX_DATES_PER_PAGE) {
            chunks.push(allDates.slice(i, i + MAX_DATES_PER_PAGE));
        }
        if (!chunks.length) chunks.push([]);

        const { yearLabel, branchLabels, classLabels, sectionLabels, monthLabel } = this.getPeriodWiseFilterSummary();
        const infoRow = (label, value) =>
            `<div style="flex:1;min-width:140px;font-size:10px;color:#374151;"><strong>${label}:</strong> ${value}</div>`;
        const summaryHtml = `<div style="margin-bottom:12px;padding:10px 12px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;">
            <div style="font-weight:700;font-size:12px;color:#4f46e5;margin-bottom:6px;">Consolidated Attendance Report</div>
            <div style="display:flex;flex-wrap:wrap;gap:8px 16px;">
                ${infoRow("Academic Year", yearLabel)}
                ${infoRow("Branch", branchLabels)}
                ${infoRow("Class", classLabels)}
                ${infoRow("Section", sectionLabels)}
                ${infoRow("Month", monthLabel)}
            </div>
        </div>`;

        return chunks.map((chunk, pageIdx) => {
            const pageLabel = chunks.length > 1
                ? `<div class="cons4-page-label">Page ${pageIdx + 1} of ${chunks.length}</div>`
                : "";
            const dateHeaders = chunk.map(date => `<th ${thStyle} colspan="3">${fmtDMY(date)}</th>`).join("");
            const subHeaders = chunk.map(() => `<th ${thStyle}>Present</th><th ${thStyle}>Absent</th><th ${thStyle}>Total</th>`).join("");
            const bodyRows = attendanceReport.map((row, idx) => {
                const dateMap = {};
                (row.dateWiseData || []).forEach(d => { dateMap[d.date] = d; });
                const dateCells = chunk.map(date => {
                    const d = dateMap[date];
                    return d
                        ? `<td ${tdStyle}>${d.present ?? "-"}</td><td ${tdStyle}>${d.absent ?? "-"}</td><td ${tdStyle}>${d.total ?? "-"}</td>`
                        : `<td ${tdStyle}>-</td><td ${tdStyle}>-</td><td ${tdStyle}>-</td>`;
                }).join("");
                return `<tr>
                    <td ${tdStyle}>${row.sr_no ?? idx + 1}</td>
                    <td ${tdStyle}>${this.resolveBranchName(row.branch_id)}</td>
                    <td ${tdStyle}>${row.class_name ?? this.resolveClassName(row.class_id)}</td>
                    <td ${tdStyle}>${this.resolveSectionName(row.section_id)}</td>
                    ${dateCells}
                </tr>`;
            }).join("");
            // ${pageIdx === 0 ? summaryHtml : ""}
            return `<div class="cons4-page">
                
                ${pageLabel}
                <table class="cons4-table">
                    <thead>
                        <tr>
                            <th ${thStyle} rowspan="2">Sr No.</th>
                            <th ${thStyle} rowspan="2">Branch</th>
                            <th ${thStyle} rowspan="2">Class</th>
                            <th ${thStyle} rowspan="2">Section</th>
                            ${dateHeaders}
                        </tr>
                        <tr>${subHeaders}</tr>
                    </thead>
                    <tbody>${bodyRows}</tbody>
                </table>
            </div>`;
        }).join("");
    };

    buildPeriodWisePrintHtml = (thStyle, tdStyle) => {
        const dateColumns = this.buildPeriodWiseDateColumns(this.state.attendanceReport);
        const chunks = this.chunkPeriodWiseDateColumns(dateColumns);
        const summaryHtml = this.buildPeriodWisePrintFilterSummaryHtml();

        return chunks.map((chunk, pageIdx) => {
            const pageNum = pageIdx + 1;
            const pageLabel = chunks.length > 1
                ? `<div class="print-page-label">Page ${pageNum} of ${chunks.length}</div>`
                : "";
            return `<div class="print-page">
                ${pageLabel}
                ${this.buildPeriodWisePrintTableHtml(thStyle, tdStyle, chunk)}
            </div>`;
        }).join("");
    };

    renderPeriodWiseReport() {
        const { attendanceReport, selectedMonthId, periodWiseSearch, periodWisePageSize } = this.state;
        if (!attendanceReport.length) return <div className="text-center py-4 text-muted">No data found</div>;

        const filteredRows = this.getPeriodWiseFilteredRows();
        const totalPages = Math.max(1, Math.ceil(filteredRows.length / periodWisePageSize) || 1);
        const currentPage = Math.min(this.state.periodWisePage, totalPages);
        const pageStart = (currentPage - 1) * periodWisePageSize;
        const pagedRows = filteredRows.slice(pageStart, pageStart + periodWisePageSize);

        const dateColumns = this.buildPeriodWiseDateColumns(attendanceReport);
        const monthTitle = this.getPeriodWiseMonthTitle(selectedMonthId);
        const filterSummary = this.getPeriodWiseFilterSummary();
        const totalPeriodCols = dateColumns.reduce((s, d) => s + d.periodCount, 0);

        const thStyle = {
            background: "#fff",
            color: "#1f2937",
            fontWeight: 700,
            fontSize: 12,
            padding: "8px 6px",
            textAlign: "center",
            border: "1px solid #e5e7eb",
            whiteSpace: "nowrap",
        };
        const subThStyle = {
            background: "#f3f4f6",
            color: "#374151",
            fontWeight: 600,
            fontSize: 11,
            padding: "6px 4px",
            textAlign: "center",
            border: "1px solid #e5e7eb",
        };
        const tdStyle = {
            padding: "5px 4px",
            textAlign: "center",
            border: "1px solid #e5e7eb",
            fontSize: 12,
        };

        // ── Frozen identity columns (toggle) + today's column ──
        const freeze = this.state.periodWiseFreeze !== false;
        // Widths of: S.No, Roll No, Student Name, Father Name, Branch, Class, Section.
        const ID_COLS = [50, 70, 160, 150, 110, 100, 100];
        const idLeft = [];
        ID_COLS.reduce((acc, w, i) => { idLeft[i] = acc; return acc + w; }, 0);
        const lastIdx = ID_COLS.length - 1;
        // Fixed widths + ellipsis are required when frozen so the sticky `left`
        // offsets line up exactly (long names can't push columns out of alignment).
        const fixedW = (i) => ({ width: ID_COLS[i], maxWidth: ID_COLS[i], overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" });
        const freezeTh = (i, base) => freeze
            ? {
                ...base, ...fixedW(i), position: "sticky", left: idLeft[i], zIndex: 6, background: "#fff",
                ...(i === lastIdx ? { boxShadow: "2px 0 5px -2px rgba(0,0,0,0.18)" } : {}),
            }
            : base;
        const freezeTd = (i, base, rowBg) => freeze
            ? {
                ...base, ...fixedW(i), position: "sticky", left: idLeft[i], zIndex: 3, background: rowBg,
                ...(i === lastIdx ? { boxShadow: "2px 0 5px -2px rgba(0,0,0,0.18)" } : {}),
            }
            : base;

        // Today (matches the resolver's zero-padded day-of-month) — only when the
        // selected month is the current month.
        const _now = new Date();
        const _curMonth = `${_now.getFullYear()}-${String(_now.getMonth() + 1).padStart(2, "0")}`;
        const todayDay = selectedMonthId === _curMonth ? String(_now.getDate()).padStart(2, "0") : null;
        const hasToday = !!todayDay && dateColumns.some((d) => d.date === todayDay);

        return (
            <div style={{ marginTop: 16 }}>
                {/* <div style={{
                    background: "linear-gradient(135deg, #eff6ff 0%, #f5f3ff 100%)",
                    borderRadius: 12,
                    padding: "14px 18px",
                    marginBottom: 14,
                    border: "1px solid #e0e7ff",
                }}>
                    <div style={{ fontWeight: 700, fontSize: 16, color: "#1e40af", marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
                        <span>📅</span> Period Wise Attendance Report
                    </div>
                    <Row className="g-2" style={{ fontSize: 12, color: "#374151" }}>
                        <Col xs={6} md={4}><strong>Academic Year:</strong> {filterSummary.yearLabel}</Col>
                        <Col xs={6} md={4}><strong>Branch:</strong> {filterSummary.branchLabels}</Col>
                        <Col xs={6} md={4}><strong>Class:</strong> {filterSummary.classLabels}</Col>
                        <Col xs={6} md={4}><strong>Section:</strong> {filterSummary.sectionLabels}</Col>
                        <Col xs={6} md={4}><strong>Month:</strong> {filterSummary.monthLabel}</Col>
                    </Row>
                </div> */}

                <Row className="g-2 align-items-end mb-3">
                    <Col xs={12} md={5}>
                        <div style={styles.label}>Search Student</div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRight: 0 }}>
                                    <i class="fa fa-search"></i>
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                style={{ ...styles.input, borderLeft: 0 }}
                                placeholder="Roll no, name, or S.No..."
                                value={periodWiseSearch}
                                onChange={this.handlePeriodWiseSearchChange}
                            />
                        </InputGroup>
                    </Col>
                </Row>

                <div style={{ display: "flex", justifyContent: "flex-start", gap: 10, marginBottom: 10, flexWrap: "wrap", alignItems: "center" }}>
                    <span style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Legend:</span>
                    {[
                        { label: "P — Present", key: "P" },
                        { label: "A — Absent", key: "A" },
                        { label: "H — Holiday", key: "H" },
                        { label: "NM — Not Marked", key: "NM" },
                    ].map(({ label, key }) => (
                        <span key={key} style={{
                            ...PERIOD_STATUS_STYLES[key],
                            padding: "3px 12px",
                            borderRadius: 4,
                            fontWeight: 700,
                            fontSize: 12,
                        }}>
                            {label}
                        </span>
                    ))}
                    <div style={{ marginLeft: "auto", display: "flex", gap: 8, alignItems: "center" }}>
                        <button
                            onClick={this.togglePeriodWiseFreeze}
                            title="Freeze / unfreeze the S.No · Roll · Name · Father · Branch · Class · Section columns"
                            style={{ display: "inline-flex", alignItems: "center", gap: 6, background: freeze ? "#4f46e5" : "#fff", color: freeze ? "#fff" : "#4f46e5", border: "1.5px solid #4f46e5", padding: "5px 14px", borderRadius: 8, fontWeight: 700, fontSize: 12, cursor: "pointer" }}
                        >
                            <i className={freeze ? "fas fa-lock" : "fas fa-lock-open"} />
                            {freeze ? "Columns Frozen" : "Columns Unfrozen"}
                        </button>
                        {hasToday && (
                            <button
                                onClick={this.scrollPwToToday}
                                style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#2563eb", color: "#fff", border: "none", padding: "5px 14px", borderRadius: 8, fontWeight: 700, fontSize: 12, cursor: "pointer" }}
                            >
                                <i className="far fa-calendar-check" /> Jump to Today
                            </button>
                        )}
                    </div>
                </div>

                {filteredRows.length === 0 ? (
                    <div className="text-center py-4 text-muted">No students match your search</div>
                ) : (
                    <>
                        <div ref={this.pwScrollRef} style={{ overflowX: "auto" }}>
                            <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 800 }}>
                                <thead>
                                    <tr>
                                        <th rowSpan={3} style={freezeTh(0, { ...thStyle, minWidth: ID_COLS[0], background: "#fff" })}>S.No.</th>
                                        <th rowSpan={3} style={freezeTh(1, { ...thStyle, minWidth: ID_COLS[1], background: "#fff" })}>Roll No.</th>
                                        <th rowSpan={3} style={freezeTh(2, { ...thStyle, minWidth: ID_COLS[2], background: "#fff", textAlign: "left" })}>Student Name</th>
                                        <th rowSpan={3} style={freezeTh(3, { ...thStyle, minWidth: ID_COLS[3] })}>Father Name</th>
                                        <th rowSpan={3} style={freezeTh(4, { ...thStyle, minWidth: ID_COLS[4] })}>Branch</th>
                                        <th rowSpan={3} style={freezeTh(5, { ...thStyle, minWidth: ID_COLS[5] })}>Class</th>
                                        <th rowSpan={3} style={freezeTh(6, { ...thStyle, minWidth: ID_COLS[6] })}>Section</th>
                                        {totalPeriodCols > 0 && (
                                            <th colSpan={totalPeriodCols} style={thStyle}>{monthTitle}</th>
                                        )}
                                    </tr>
                                    <tr>
                                        {dateColumns.map((d) => {
                                            const isToday = d.date === todayDay;
                                            return (
                                                <th
                                                    key={d.date}
                                                    colSpan={d.periodCount}
                                                    ref={isToday ? this.setPwTodayColRef : null}
                                                    style={{
                                                        ...thStyle,
                                                        background: isToday ? "#dbeafe" : (d.is_holiday ? "#3b82f6" : thStyle.background),
                                                        color: isToday ? "#1d4ed8" : thStyle.color,
                                                        ...(isToday ? { borderBottom: "2px solid #2563eb" } : {}),
                                                    }}
                                                >
                                                    {isToday ? "📅 " : ""}{d.dateLabel}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                    <tr>
                                        {dateColumns.map((d) => {
                                            const isToday = d.date === todayDay;
                                            return Array.from({ length: d.periodCount }, (_, i) => {
                                                const periodLabel = d.periodLabels?.[i] || `P${i + 1}`;
                                                return (
                                                    <th
                                                        key={`${d.date}-p${i + 1}`}
                                                        style={{ ...subThStyle, maxWidth: 72, overflow: "hidden", textOverflow: "ellipsis", ...(isToday ? { background: "#eff6ff", color: "#1d4ed8" } : {}) }}
                                                        title={periodLabel}
                                                    >
                                                        {periodLabel}
                                                    </th>
                                                );
                                            });
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {pagedRows.map((row, idx) => {
                                        const dateMap = {};
                                        (row.dateWiseData || []).forEach((d) => { dateMap[d.date] = d; });
                                        const displaySrNo = row.sr_no ?? (pageStart + idx + 1);
                                        const rowBg = idx % 2 === 0 ? "#f9fafb" : "#fff";
                                        return (
                                            <tr key={`${row.student_id}-${pageStart + idx}`} style={{ background: rowBg }}>
                                                <td style={freezeTd(0, { ...tdStyle }, rowBg)}>{displaySrNo}</td>
                                                <td style={freezeTd(1, { ...tdStyle }, rowBg)}>{row.roll_no ?? "-"}</td>
                                                <td title={row.student_name || ""} style={freezeTd(2, { ...tdStyle, textAlign: "left", fontWeight: 500 }, rowBg)}>{row.student_name ?? "-"}</td>
                                                <td title={row.father_name || ""} style={freezeTd(3, { ...tdStyle, textAlign: "left" }, rowBg)}>{row.father_name ?? "-"}</td>
                                                <td style={freezeTd(4, { ...tdStyle, textAlign: "left" }, rowBg)}>{this.resolveBranchName(row.branch_id)}</td>
                                                <td style={freezeTd(5, { ...tdStyle, textAlign: "left", fontWeight: 600, color: "#4f46e5" }, rowBg)}>{this.resolveClassName(row.class_id)}</td>
                                                <td style={freezeTd(6, { ...tdStyle, textAlign: "left" }, rowBg)}>{this.resolveSectionName(row.section_id)}</td>
                                                {dateColumns.map((d) => {
                                                    const dayData = dateMap[d.date];
                                                    const isToday = d.date === todayDay;
                                                    return Array.from({ length: d.periodCount }, (_, i) => {
                                                        const period = (dayData?.periods || []).find((x) => +x.period_no === i + 1);
                                                        const cellBg = (isToday || d.is_holiday) ? "#eff6ff" : undefined;
                                                        return (
                                                            <td key={`${d.date}-${i}`} style={{ ...tdStyle, background: cellBg }}>
                                                                {this.renderPeriodStatusCell(period?.status, dayData?.is_holiday)}
                                                            </td>
                                                        );
                                                    });
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        {this.renderPeriodWisePagination(filteredRows.length)}
                    </>
                )}
            </div>
        );
    }

    renderConsolidatedReport() {
        const { attendanceReport, consolidated4Search, consolidated4PageSize } = this.state;
        if (!attendanceReport.length) return <div className="text-center py-4 text-muted">No data found</div>;

        const filteredRows = this.getConsolidatedFilteredRows();
        const totalPages = Math.max(1, Math.ceil(filteredRows.length / consolidated4PageSize) || 1);
        const currentPage = Math.min(this.state.consolidated4Page, totalPages);
        const pageStart = (currentPage - 1) * consolidated4PageSize;
        const pagedRows = filteredRows.slice(pageStart, pageStart + consolidated4PageSize);

        const allDates = [];
        const seenDates = new Set();
        attendanceReport.forEach((row) => {
            (row.dateWiseData || []).forEach((d) => {
                if (!seenDates.has(d.date)) { seenDates.add(d.date); allDates.push(d.date); }
            });
        });
        allDates.sort();

        // Today, in the same DD-MM-YYYY format the resolver emits, so we can
        // highlight + scroll to today's column.
        const _pad2 = (n) => String(n).padStart(2, "0");
        const _now = new Date();
        const todayStr = `${_pad2(_now.getDate())}-${_pad2(_now.getMonth() + 1)}-${_now.getFullYear()}`;
        const hasToday = allDates.includes(todayStr);

        const thStyle = { background: "#fff", color: "#1f2937", fontWeight: 700, fontSize: 12, padding: "8px 6px", textAlign: "center", border: "1px solid #e5e7eb", whiteSpace: "nowrap" };
        const subThStyle = { background: "#f3f4f6", color: "#374151", fontWeight: 600, fontSize: 11, padding: "6px 4px", textAlign: "center", border: "1px solid #e5e7eb" };
        const tdStyle = { padding: "7px 6px", textAlign: "center", border: "1px solid #e5e7eb", fontSize: 13 };
        const numStyle = (color) => ({ color, fontWeight: 700 });

        const stickyCols = [
            { label: "Sr No.", width: 48 },
            { label: "Branch", width: 110 },
            { label: "Class", width: 100 },
            { label: "Section", width: 100 },
        ];
        const colClassNames = [
            "sticky-con-sr",
            "sticky-con-branch",
            "sticky-con-class",
            "sticky-con-section",
        ];
        const stickyTh = (col) => ({
            ...thStyle,
            minWidth: col.width,
            width: col.width,
            background: "#fff",
        });
        const stickyTd = (col, rowBg) => ({
            ...tdStyle,
            minWidth: col.width,
            width: col.width,
            background: rowBg,
        });

        const filterSummary = this.getPeriodWiseFilterSummary();

        return (
            <div style={{ marginTop: 16 }}>
                {/* <div style={{
                    background: "linear-gradient(135deg, #eff6ff 0%, #f5f3ff 100%)",
                    borderRadius: 12,
                    padding: "14px 18px",
                    marginBottom: 14,
                    border: "1px solid #e0e7ff",
                }}>
                    <div style={{ fontWeight: 700, fontSize: 16, color: "#1e40af", marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
                        <span>📊</span> Consolidated Attendance Report
                    </div>
                    <Row className="g-2" style={{ fontSize: 12, color: "#374151" }}>
                        <Col xs={6} md={4}><strong>Academic Year:</strong> {filterSummary.yearLabel}</Col>
                        <Col xs={6} md={4}><strong>Branch:</strong> {filterSummary.branchLabels}</Col>
                        <Col xs={6} md={4}><strong>Class:</strong> {filterSummary.classLabels}</Col>
                        <Col xs={6} md={4}><strong>Section:</strong> {filterSummary.sectionLabels}</Col>
                        <Col xs={6} md={4}><strong>Month:</strong> {filterSummary.monthLabel}</Col>
                    </Row>
                </div> */}

                {this.renderReportSearchAndPageSize({
                    searchValue: consolidated4Search,
                    onSearchChange: this.handleConsolidatedSearchChange,
                    searchPlaceholder: "Sr no, branch, class, or section...",
                })}

                {filteredRows.length === 0 ? (
                    <div className="text-center py-4 text-muted">No rows match your search</div>
                ) : (
                    <>
                        <div style={{ display: "flex", justifyContent: "flex-start", gap: 10, marginBottom: 10, flexWrap: "wrap", alignItems: "center" }}>
                            <span style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Legend:</span>
                            {[
                                { label: "Present", bg: "#37c978" },
                                { label: "Absent", bg: "#e11d48" },
                                { label: "Total", bg: "#4169e1" },
                            ].map(({ label, bg }) => (
                                <span key={label} style={{ background: bg, color: "#fff", padding: "3px 12px", borderRadius: 4, fontWeight: 700, fontSize: 12 }}>
                                    {label}
                                </span>
                            ))}
                            {hasToday && (
                                <button
                                    onClick={this.scrollToToday}
                                    style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 6, background: "#2563eb", color: "#fff", border: "none", padding: "5px 14px", borderRadius: 8, fontWeight: 700, fontSize: 12, cursor: "pointer" }}
                                >
                                    <i className="far fa-calendar-check" /> Jump to Today ({fmtDMY(todayStr)})
                                </button>
                            )}
                        </div>

                        <div ref={this.cons4ScrollRef} style={{ overflowX: "auto" }}>
                            <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 600 }}>
                                <thead>
                                    <tr>
                                        {stickyCols.map((col, cIdx) => (
                                            <th key={col.label} className={colClassNames[cIdx]} rowSpan={2} style={stickyTh(col)}>{col.label}</th>
                                        ))}
                                        {allDates.map((date) => {
                                            const isToday = date === todayStr;
                                            return (
                                                <th
                                                    key={date}
                                                    colSpan={3}
                                                    ref={isToday ? this.setTodayColRef : null}
                                                    style={{ ...thStyle, minWidth: 150, ...(isToday ? { background: "#eff6ff", color: "#1d4ed8", borderBottom: "2px solid #2563eb" } : {}) }}
                                                >
                                                    {isToday ? "📅 Today · " : ""}{fmtDMY(date)}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                    <tr>
                                        {allDates.map((date) => {
                                            const isToday = date === todayStr;
                                            const sub = isToday ? { ...subThStyle, background: "#dbeafe", color: "#1d4ed8" } : subThStyle;
                                            return (
                                                <React.Fragment key={date}>
                                                    <th style={{ ...sub, minWidth: 50 }}>Present</th>
                                                    <th style={{ ...sub, minWidth: 50 }}>Absent</th>
                                                    <th style={{ ...sub, minWidth: 50 }}>Total</th>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {pagedRows.map((row, idx) => {

                                        const dateMap = {};
                                        (row.dateWiseData || []).forEach((d) => { dateMap[d.date] = d; });
                                        const rowBg = idx % 2 === 0 ? "#f9fafb" : "#fff";
                                        const displaySrNo = row.sr_no ?? (pageStart + idx + 1);
                                        return (
                                            <tr key={`${row.branch_id}-${row.class_id}-${row.section_id}-${pageStart + idx}`} style={{ background: rowBg }}>
                                                <td className="sticky-con-sr" style={stickyTd(stickyCols[0], rowBg)}>{displaySrNo}</td>
                                                <td className="sticky-con-branch" style={{ ...stickyTd(stickyCols[1], rowBg), textAlign: "left" }}>{this.resolveBranchName(row.branch_id)}</td>
                                                <td className="sticky-con-class" style={{ ...stickyTd(stickyCols[2], rowBg), textAlign: "left", fontWeight: 600, color: "#4f46e5" }}>{row.class_name || this.resolveClassName(row.class_id)}</td>
                                                <td className="sticky-con-section" style={{ ...stickyTd(stickyCols[3], rowBg), textAlign: "left" }}>{this.resolveSectionName(row.section_id)}</td>
                                                {allDates.map((date) => {
                                                    const d = dateMap[date];
                                                    const isToday = date === todayStr;
                                                    const cellStyle = isToday ? { ...tdStyle, background: "#eff6ff" } : tdStyle;
                                                    return (
                                                        <React.Fragment key={date}>
                                                            <td style={cellStyle}>{d ? <span style={numStyle("#37c978")}>{d.present ?? "-"}</span> : "-"}</td>
                                                            <td style={cellStyle}>{d ? <span style={numStyle("#e11d48")}>{d.absent ?? "-"}</span> : "-"}</td>
                                                            <td style={cellStyle}>{d ? <span style={numStyle("#4169e1")}>{d.total ?? "-"}</span> : "-"}</td>
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        {this.renderReportPagination(
                            filteredRows.length,
                            this.state.consolidated4Page,
                            consolidated4PageSize,
                            this.handleConsolidatedPageChange,
                            (val) => this.handleConsolidatedPageSizeChange({ target: { value: val } }),
                            "row"
                        )}
                    </>
                )}
            </div>
        );
    }
    render() {
        // is_view === 0 → the attendance report is never rendered, the two queries below
        // are skipped, and componentDidMount/DidUpdate bail before fetching anything else.
        if (!this.guard.canView()) {
            return (
                <div style={styles.page}>
                    <AccessDeniedCard />
                </div>
            );
        }

        const { selected, branchData, selectedBranch, selectedClass, attendanceReport, isBranchLoading } = this.state;
        // Branch is always controlled upstream — by the parent's branchIds prop on
        // attendance-regularization, and by the header multi-select (NavbarOne) everywhere
        // else — so this component never renders a Branch picker.
        const filtersToRender = this.state.mainSource === "biometric" 
            ? BIOMETRIC_FILTERS 
            : (this.state.mainSource === "manual" ? MANUAL_FILTERS : CONSOLIDATED_FILTERS);

        const dayColumns = selected === 2 && attendanceReport.length > 0
            ? [...(attendanceReport[0].days || [])]
                .sort((a, b) => a.day - b.day)
                .map((d) => ({
                    dataField: `day_${d.day}`,
                    text: String(d.day),
                    style: { width: 100, minWidth: 100, textAlign: "center", verticalAlign: "middle" },
                    headerStyle: { width: 100, minWidth: 100, textAlign: "center", background: "#fff", color: "#1f2937" },
                    formatter: (cell, row) => {
                        const entry = (row.days || []).find((x) => x.day === d.day);
                        const status = entry?.status;
                        if (!status || status === "NM") return "-";

                        let bg = "#f1f5f9"; // default NM / fallback
                        let color = "#475569";
                        let text = status;
                        let icon = null;
                        let borderStyle = "none";

                        if (status === "P") {
                            bg = "#dcfce7"; // soft green for biometric present
                            color = "#15803d";
                            text = "P";
                        } else if (status === "PM") {
                            bg = "#ccfbf1"; // soft teal for manual override present
                            color = "#0f766e";
                            text = "P";
                            borderStyle = "1px dashed #0f766e";
                            icon = <i className="fas fa-edit" style={{ fontSize: 9, marginLeft: 3 }} title="Manual Override" />;
                        } else if (status === "A") {
                            bg = "#fee2e2"; // soft red for biometric absent
                            color = "#b91c1c";
                            text = "A";
                        } else if (status === "AM") {
                            bg = "#ffedd5"; // soft orange for manual override absent
                            color = "#c2410c";
                            text = "A";
                            borderStyle = "1px dashed #c2410c";
                            icon = <i className="fas fa-edit" style={{ fontSize: 9, marginLeft: 3 }} title="Manual Override" />;
                        } else if (status === "S") {
                            bg = "#f3e8ff"; // soft purple for sick
                            color = "#7e22ce";
                            text = "S";
                            borderStyle = "1px dashed #7e22ce";
                            icon = <i className="fas fa-notes-medical" style={{ fontSize: 9, marginLeft: 3 }} title="Sick Leave" />;
                        } else if (status === "H") {
                            bg = "#e0f2fe"; // soft blue for holiday
                            color = "#0369a1";
                            text = "H";
                        } else if (status === "SUNDAY") {
                            bg = "#f3f4f6"; // soft gray
                            color = "#4b5563";
                            text = "SUN";
                        }

                        return (
                            <span style={{
                                backgroundColor: bg,
                                color: color,
                                padding: "4px 8px",
                                borderRadius: "8px",
                                fontWeight: "800",
                                fontSize: "11px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: "48px",
                                border: borderStyle,
                                boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                            }}>
                                {text}{icon}
                            </span>
                        );
                    },
                }))
            : [];

        const activeColumns = selected === 2
            ? [...this.selected2Columns, ...dayColumns]
            : selected === 3
                ? this.selected3Columns
                : selected === 10
                    ? this.selected10Columns
                    : selected === 11
                        ? this.selected11Columns
                        : selected === 12
                            ? this.selected12Columns
                            : this.selected1Columns;

        const allClasses = this.props.getClassesQuery?.getExamClasses || [];

        // Union of every branch the header has in scope, not just the one selectedBranch.
        const selectedBranchesData = this.inScopeBranches();

        const classArr = (() => {
            const allClassIds = [...new Set(selectedBranchesData.flatMap((b) => b.sections.map((s) => s.class_id)))];
            return this.sortByLabelAsc(
                allClassIds
                    .map((classId) => {
                        const classData = allClasses.find((c) => +c.id === +classId);
                        return classData ? { value: classData.id, label: classData.class } : null;
                    })
                    .filter(Boolean)
            );
        })();

        // Does the current class selection match this section's class? (none picked = all)
        const sectionClassMatch = (s) => {
            if (!this.state.classSelectedvalue.length) return true;
            return this.state.classSelectedvalue.some((cv) => +cv.value === +s.class_id);
        };

        // Stream options — distinct streams among the in-scope stream-class sections
        const streamArr = this.sortByLabelAsc(
            [...new Set(
                selectedBranchesData
                    .flatMap((b) => b.sections)
                    .filter((s) => sectionClassMatch(s) && isStreamClass(s.class_id) && s.stream_id)
                    .map((s) => String(s.stream_id))
            )]
                .map((sid) => {
                    const st = (this.state.allStreams || []).find((x) => +x.id === +sid);
                    return st ? { value: st.id, label: st.stream } : null;
                })
                .filter(Boolean)
        );
        const showStream = streamArr.length > 0;
        const selectedStreamVal = this.state.streamSelectedvalue === null ? streamArr : this.state.streamSelectedvalue;

        // Sections narrowed by class and (for stream classes) by the selected streams. Empty stream selection = all.
        const sectionArr = this.buildSectionOptions(selectedBranchesData, (s) => {
            if (!sectionClassMatch(s)) return false;
            if (isStreamClass(s.class_id) && selectedStreamVal && selectedStreamVal.length > 0) {
                return selectedStreamVal.some((sv) => +sv.value === +s.stream_id);
            }
            return true;
        });

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        if (classArr.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "Class"
        }

        if (sectionArr.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "Section"
        }

        return (
            <div style={styles.page}>
                <div style={styles.card}>
                    <div style={styles.cardBody}>


                        {/* Report type sub-tabs */}
                        <Row className="align-items-center g-2 border-bottom pb-2 mb-2">
                            <Col xs={12} md={9}>
                                <Tabs
                                    activeKey={selected}
                                    onSelect={(key) => this.handleSelect(Number(key))}
                                    className="custom-attendance-tabs border-bottom-0 mb-0"
                                >
                                    {filtersToRender.map((filter) => (
                                        <Tab
                                            eventKey={filter.value}
                                            title={
                                                <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                    <i className={filter.icon} style={{ fontSize: "16px", color: selected === filter.value ? "#6366f1" : "#4b5563" }}></i>
                                                    <span style={{ color: selected === filter.value ? "#6366f1" : "#4b5563" }}>{filter.label}</span>
                                                </div>
                                            }
                                            key={filter.value}
                                        />
                                    ))}
                                </Tabs>
                            </Col>
                            <Col xs={12} md={3} className="text-right d-flex justify-content-end">
                                <Button
                                    name="addAttendace"
                                    style={styles.addAttendanceBtn}
                                    onClick={() => { if (this.addAttendanceGuard.requireEdit()) this.props.history.push("/student/attendance"); }}
                                >
                                    <i className="fas fa-plus" style={{ marginRight: 6 }}></i> Add Attendance
                                </Button>
                            </Col>
                        </Row>

                        {/* Filters */}
                        <style>{`
                            .attendance-filters .css-yk16xz-control,
                            .attendance-filters .css-1pahdxg-control,
                            .attendance-filters .dropdown-container {
                                border: 1.5px solid #e5e7eb !important;
                                border-radius: 10px !important;
                                background: #f9fafb !important;
                                min-height: 42px !important;
                                box-shadow: none !important;
                            }
                            .attendance-filters .css-1pahdxg-control,
                            .attendance-filters .dropdown-container:focus-within {
                                border-color: #6366f1 !important;
                            }
                        `}</style>
                        <Row className="g-3 align-items-end attendance-filters" style={{ borderTop: "1.5px solid #f0f4ff", }}>
                            <Col xs={12} sm={6} md={4} lg={2}>
                                <div style={styles.label}><i className="far fa-calendar-check" style={styles.labelIcon} />Academic Year</div>
                                <SelectDropDown
                                    name="selectedYear"
                                    placeholderName="Select Academic Year"
                                    options={this.sortAcademicYearsAsc(this.props.getAcademicYearsQuery?.getAcademicYears).map(year => ({ value: year.id, label: year.academic_year }))}
                                    stateData={this.state.yearSelectedvalue?.[0] || null}
                                    handleChange={(name, value) => this.handleDropdown(name, { target: { value } })}
                                    isClearable={false}
                                />
                            </Col>

                            {/* No Branch picker — branch scope is owned by the header (NavbarOne). */}

                            <Col xs={12} sm={6} md={4} lg={2}>
                                <div style={styles.label}><i className="fas fa-graduation-cap" style={styles.labelIcon} />Select Class</div>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Classes selected.",
                                        "selectSomeItems": classlabelledBy,
                                    }}
                                    disableSearch={classdisableSearch}
                                    hasSelectAll={classselectall}
                                    options={classArr}
                                    value={this.state.classSelectedvalue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                    labelledBy={"class"}
                                />
                                <span className="text-danger f-16">{this.state.classError}</span>
                            </Col>

                            {showStream && (
                                <Col xs={12} sm={6} md={4} lg={2}>
                                    <div style={styles.label}><i className="fas fa-stream" style={styles.labelIcon} />Select Stream</div>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Streams selected.",
                                            "selectSomeItems": "Stream",
                                        }}
                                        options={streamArr}
                                        value={selectedStreamVal}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "stream")}
                                        labelledBy={"stream"}
                                    />
                                </Col>
                            )}

                            {(selected === 1 || selected === 2 || selected === 3 || selected === 4 || selected === 5) && (
                                <Col xs={12} sm={6} md={4} lg={2}>
                                    <div style={styles.label}><i className="fas fa-layer-group" style={styles.labelIcon} />Select Section</div>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Sections selected.",
                                            "selectSomeItems": sectionlabelledBy,
                                        }}
                                        disableSearch={sectiondisableSearch}
                                        hasSelectAll={sectionselectall}
                                        options={sectionArr}
                                        value={this.state.sectionSelectedvalue}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                        labelledBy={"section"}
                                        disabled={
                                            (selected === 4 || selected === 5)
                                                ? !this.state.branchSelectedvalue.length || !this.state.classSelectedvalue.length
                                                : !selectedBranch || ((selected === 1 || selected === 2) && !selectedClass)
                                        }
                                    />
                                    <span className="text-danger f-16">{this.state.sectionError}</span>
                                </Col>
                            )}

                            {selected === 1 || selected === 3 ? (
                                <Col xs={12} sm={6} md={4} lg={3}>
                                    <div style={styles.label}><i className="fas fa-calendar-alt" style={styles.labelIcon} />Select Date Range</div>
                                    <Form.Group className="customDate mb-0" controlId="StartDate">
                                        <ReportDateBlock
                                            applyCallback={this.applyCallback}
                                            start={this.start}
                                            end={this.end}
                                            stateData={this.props.stateData}
                                        />
                                    </Form.Group>
                                </Col>
                            ) : (selected === 2 || selected === 4 || selected === 5) ? (
                                <Col xs={12} sm={6} md={4} lg={3}>
                                    <div style={styles.label}><i className="fas fa-calendar" style={styles.labelIcon} />Select Month</div>
                                    <SelectDropDown
                                        name="selectedMonthId"
                                        placeholderName="Select Month"
                                        options={monthOptions}
                                        stateData={this.state.monthSelectedvalue?.[0] || null}
                                        handleChange={(name, value) => this.handleDropdown(name, { target: { value } })}
                                        isClearable={false}
                                        isDisabled={!(selected === 4 || selected === 5) && !selectedClass}
                                    />
                                </Col>
                            ) : null}
                        </Row>

                        {(this.state.isClassFilterLoader === 1 || this.state.hasSearched || isBranchLoading) && (
                            <div style={{ borderTop: "1.5px solid #f0f4ff", paddingTop: 16, marginTop: 4 }}>
                                {(this.state.isClassFilterLoader === 1 || isBranchLoading) ? (
                                    <div className="py-4">
                                        <style>
                                            {`
                                                @keyframes shimmerLoading {
                                                    0% { background-position: -1000px 0; }
                                                    100% { background-position: 1000px 0; }
                                                }
                                                .shimmer-line {
                                                    height: 20px;
                                                    margin-bottom: 15px;
                                                    background: #f6f7f8;
                                                    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                                                    background-repeat: no-repeat;
                                                    background-size: 1000px 100%;
                                                    animation: shimmerLoading 1.5s infinite linear forwards;
                                                    border-radius: 4px;
                                                }
                                                .shimmer-header { height: 40px; margin-bottom: 24px; border-radius: 8px; }
                                            `}
                                        </style>
                                        <div className="shimmer-line shimmer-header" style={{ width: '100%' }}></div>
                                        <div className="shimmer-line" style={{ width: '100%' }}></div>
                                        <div className="shimmer-line" style={{ width: '100%' }}></div>
                                        <div className="shimmer-line" style={{ width: '100%' }}></div>
                                        <div className="shimmer-line" style={{ width: '100%' }}></div>
                                        <div className="shimmer-line" style={{ width: '80%' }}></div>
                                    </div>
                                ) : (
                                    <div>
                                        {this.state.attendanceReport.length > 0 && (
                                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginBottom: 12 }}>
                                                <button
                                                    onClick={this.downloadExcel}
                                                    style={{
                                                        background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                                                        border: "none", borderRadius: 8, padding: "8px 18px",
                                                        fontWeight: 700, fontSize: 13, color: "#fff",
                                                        cursor: "pointer", display: "flex", alignItems: "center", gap: 6,
                                                        boxShadow: "0 3px 10px rgba(16,185,129,0.3)",
                                                    }}
                                                >
                                                    <i className="fas fa-file-excel"></i> Excel
                                                </button>
                                                <button
                                                    onClick={this.printReport}
                                                    style={{
                                                        background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                                                        border: "none", borderRadius: 8, padding: "8px 18px",
                                                        fontWeight: 700, fontSize: 13, color: "#fff",
                                                        cursor: "pointer", display: "flex", alignItems: "center", gap: 6,
                                                        boxShadow: "0 3px 10px rgba(99,102,241,0.3)",
                                                    }}
                                                >
                                                    <i className={selected === 5 ? "fas fa-file-pdf" : "fas fa-print"}></i> {selected === 5 ? "PDF" : "Print"}
                                                </button>
                                            </div>
                                        )}

                                        {this.renderSummaryStats()}

                                        {selected === 4 ? (
                                            this.renderConsolidatedReport()
                                        ) : selected === 5 ? (
                                            this.renderPeriodWiseReport()
                                        ) : (
                                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                                {selected === 2 && this.state.attendanceReport.length > 0 && (
                                                    <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap", alignItems: "center" }}>
                                                        <span style={{ fontWeight: 700, fontSize: 12, color: "#4b5563", textTransform: "uppercase", letterSpacing: "0.5px", marginRight: 4 }}>Legend:</span>
                                                        {[
                                                            // Manual Attendance never emits the biometric statuses ("P"/"A" —
                                                            // the resolver treats every row as manual there), so listing them
                                                            // in its legend describes states that cannot appear.
                                                            { text: "P", label: "Biometric Present", bg: "#dcfce7", color: "#15803d", biometricOnly: true },
                                                            { text: "P", label: this.state.mainSource === "manual" ? "Present" : "Manual Present", bg: "#ccfbf1", color: "#0f766e", border: "1px dashed #0f766e", icon: "fa-edit" },
                                                            { text: "A", label: "Absent (No Punch)", bg: "#fee2e2", color: "#b91c1c", biometricOnly: true },
                                                            { text: "A", label: this.state.mainSource === "manual" ? "Absent" : "Manual Absent", bg: "#ffedd5", color: "#c2410c", border: "1px dashed #c2410c", icon: "fa-edit" },
                                                            { text: "S", label: this.state.mainSource === "manual" ? "Sick" : "Sick (Manual)", bg: "#f3e8ff", color: "#7e22ce", border: "1px dashed #7e22ce", icon: "fa-notes-medical" },
                                                            { text: "H", label: "Holiday", bg: "#e0f2fe", color: "#0369a1" },
                                                            { text: "SUN", label: "Sunday", bg: "#f3f4f6", color: "#4b5563" },
                                                        ].filter((item) => !(item.biometricOnly && this.state.mainSource === "manual")).map((item) => (
                                                            <div key={item.label} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#fff", padding: "4px 10px", borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", border: "1px solid #e5e7eb" }}>
                                                                <span style={{
                                                                    backgroundColor: item.bg,
                                                                    color: item.color,
                                                                    padding: "2px 6px",
                                                                    borderRadius: "6px",
                                                                    fontWeight: "800",
                                                                    fontSize: "10px",
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    minWidth: "32px",
                                                                    border: item.border || "none"
                                                                }}>
                                                                    {item.text}
                                                                    {item.icon && <i className={`fas ${item.icon}`} style={{ fontSize: 8, marginLeft: 2 }} />}
                                                                </span>
                                                                <span style={{ fontSize: 11.5, color: "#4b5563", fontWeight: 600 }}>{item.label}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                {this.state.attendanceReport.length > 0 ? (

                                                    <Row className="mt-1">
                                                        <Col sm={12}>
                                                            <div
                                                                style={{
                                                                    background: "#ffffff",
                                                                    borderRadius: "18px",
                                                                    padding: "18px",
                                                                    boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
                                                                }}
                                                            >
                                                                <CardLessDataTableWithSearch
                                                                    parentData={this.state.attendanceReport}
                                                                    particlecolumns={activeColumns}
                                                                    name="hostel_attendance"
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                ) : (
                                                    <div className="text-center py-4 text-muted">No data found</div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <StudentAttendanceModal
                    show={this.state.attendanceModalShow}
                    onHide={() => this.setState({ attendanceModalShow: false })}
                />
                {this.renderDetailsContainer()}

                {/* Shown when a role without is_edit clicks Add Attendance. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.addAttendanceGuard.hideAccessDenied}
                />
            </div>
        );
    }
}

export default withRouter(
    withApollo(
        compose(
            // skip: is_view === 0 → don't fetch. Both are READ queries; there are no
            // mutations in this component, so nothing here must be left un-skipped.
            graphql(GET_ACADEMIC_YEARS, {
                name: "getAcademicYearsQuery",
                options: { variables: { id: 1 } },
                fetchPolicy: "network-only",
                skip: () => !canView(ATTENDANCE_REGULARIZATION_MODULE),
            }),
            graphql(GET_CLASSES, {
                name: "getClassesQuery",
                options: { variables: { id: parseInt(Cookies.get("institutionid")) } },
                fetchPolicy: "network-only",
                skip: () => !canView(ATTENDANCE_REGULARIZATION_MODULE),
            }),
        )(StudentAttendanceReportHome),
    ),
);